"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ABOVE_OR_BELOW () {
        return ABOVE_OR_BELOW;
    },
    get ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE () {
        return ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE;
    },
    get ACCESS_CONTROL_ENTITY_TYPE () {
        return ACCESS_CONTROL_ENTITY_TYPE;
    },
    get ACCESS_CONTROL_RESOURCE_TYPE () {
        return ACCESS_CONTROL_RESOURCE_TYPE;
    },
    get ACCOUNT_DFE_RULE_NAME () {
        return ACCOUNT_DFE_RULE_NAME;
    },
    get ACCOUNT_SISD_RULE_NAME () {
        return ACCOUNT_SISD_RULE_NAME;
    },
    get ACCOUNT_WEBHOOK_TYPE () {
        return ACCOUNT_WEBHOOK_TYPE;
    },
    get ACTIVITY_TARGET_TYPE () {
        return ACTIVITY_TARGET_TYPE;
    },
    get ACTIVITY_TYPE () {
        return ACTIVITY_TYPE;
    },
    get ADDRESS_STANDARDIZERS () {
        return ADDRESS_STANDARDIZERS;
    },
    get ADJACENT_GRADE_TYPE () {
        return ADJACENT_GRADE_TYPE;
    },
    get AI_ACTION_RUN_STATUS () {
        return AI_ACTION_RUN_STATUS;
    },
    get ARCGIS_EXPORT_FREQUENCY () {
        return ARCGIS_EXPORT_FREQUENCY;
    },
    get ARC_GIS_TYPE_TO_DATA_TYPE () {
        return ARC_GIS_TYPE_TO_DATA_TYPE;
    },
    get AUTOMATION_NODE_TYPE () {
        return AUTOMATION_NODE_TYPE;
    },
    get AUTOMATION_RESOURCE_TYPE () {
        return AUTOMATION_RESOURCE_TYPE;
    },
    get AUTOMATION_TRIGGER_TYPE () {
        return AUTOMATION_TRIGGER_TYPE;
    },
    get AWS_BATCH_JOB_STATUS () {
        return AWS_BATCH_JOB_STATUS;
    },
    get AWS_BATCH_JOB_TYPE () {
        return AWS_BATCH_JOB_TYPE;
    },
    get BASE_CUSTOM_MAP_GEOMETRY_TYPE () {
        return BASE_CUSTOM_MAP_GEOMETRY_TYPE;
    },
    get BASE_FLOOD_ELEVATION_SOURCE () {
        return BASE_FLOOD_ELEVATION_SOURCE;
    },
    get BASE_MAP_SOURCE_TYPE () {
        return BASE_MAP_SOURCE_TYPE;
    },
    get BATCH_JOB_MAIN_CONTAINER_NAME () {
        return BATCH_JOB_MAIN_CONTAINER_NAME;
    },
    get BOOLEAN_OPTIONS () {
        return BOOLEAN_OPTIONS;
    },
    get BUILDING_DIAGRAM_NUMBERS () {
        return BUILDING_DIAGRAM_NUMBERS;
    },
    get BUILDING_ELEVATION_SOURCE () {
        return BUILDING_ELEVATION_SOURCE;
    },
    get BUILDING_LOCATED_IN_CBRS_OR_OPA () {
        return BUILDING_LOCATED_IN_CBRS_OR_OPA;
    },
    get BUILDING_USE () {
        return BUILDING_USE;
    },
    get CBRS_TYPE () {
        return CBRS_TYPE;
    },
    get CBRS_TYPE_SORT_ORDER () {
        return CBRS_TYPE_SORT_ORDER;
    },
    get CERTIFICATE_TYPE () {
        return CERTIFICATE_TYPE;
    },
    get CERTIFICATE_UPLOAD_CANCELATION_REASON () {
        return CERTIFICATE_UPLOAD_CANCELATION_REASON;
    },
    get CERTIFICATE_UPLOAD_STATUS () {
        return CERTIFICATE_UPLOAD_STATUS;
    },
    get CERTIFICATE_VERSION () {
        return CERTIFICATE_VERSION;
    },
    get COASTAL_A_DETERMINATION () {
        return COASTAL_A_DETERMINATION;
    },
    get COMMENT_CREATED_BY_TYPE () {
        return COMMENT_CREATED_BY_TYPE;
    },
    get COMMENT_OBJECT_TYPE () {
        return COMMENT_OBJECT_TYPE;
    },
    get COMMON_BASE_MAP_STYLES () {
        return COMMON_BASE_MAP_STYLES;
    },
    get CONDITIONAL_RULE_EFFECT_ACTION () {
        return CONDITIONAL_RULE_EFFECT_ACTION;
    },
    get CONFIRM_EMAIL_ERROR_CODE () {
        return CONFIRM_EMAIL_ERROR_CODE;
    },
    get CREATED_BY_TYPE () {
        return CREATED_BY_TYPE;
    },
    get CREATOR_TYPE () {
        return CREATOR_TYPE;
    },
    get CUSTOM_MAP_GEOMETRY_TYPE () {
        return CUSTOM_MAP_GEOMETRY_TYPE;
    },
    get CUSTOM_MAP_TYPE () {
        return CUSTOM_MAP_TYPE;
    },
    get DAMAGE_DEGREE () {
        return DAMAGE_DEGREE;
    },
    get DATA_TYPE () {
        return DATA_TYPE;
    },
    get DATUM_CONVERSION_OFFSET_PURPOSE () {
        return DATUM_CONVERSION_OFFSET_PURPOSE;
    },
    get DATUM_CONVERSION_OFFSET_SOURCE () {
        return DATUM_CONVERSION_OFFSET_SOURCE;
    },
    get DEFAULT_MAP_STYLES () {
        return DEFAULT_MAP_STYLES;
    },
    get DEFAULT_PARCEL_IMPORT_FIELD_LABELS () {
        return DEFAULT_PARCEL_IMPORT_FIELD_LABELS;
    },
    get DEFAULT_PROPERTY_FIRM () {
        return DEFAULT_PROPERTY_FIRM;
    },
    get DEFAULT_PUBLIC_USER_GROUP_NAME () {
        return DEFAULT_PUBLIC_USER_GROUP_NAME;
    },
    get DEFAULT_SAVED_VIEW_TILE_LAYER () {
        return DEFAULT_SAVED_VIEW_TILE_LAYER;
    },
    get DESIGN_FLOOD_ELEVATION_TYPE () {
        return DESIGN_FLOOD_ELEVATION_TYPE;
    },
    get DFE_DETERMINATION_METHOD () {
        return DFE_DETERMINATION_METHOD;
    },
    get DFE_RULE_TYPE () {
        return DFE_RULE_TYPE;
    },
    get DFE_UNIT_OF_MEASUREMENT () {
        return DFE_UNIT_OF_MEASUREMENT;
    },
    get DOCUMENT_TYPE_NAME () {
        return DOCUMENT_TYPE_NAME;
    },
    get DOCUMENT_UPLOAD_DETAIL_TAB_NAME () {
        return DOCUMENT_UPLOAD_DETAIL_TAB_NAME;
    },
    get EC_CONFIGURATION_FLOOD_MAP_RESTRICTION () {
        return EC_CONFIGURATION_FLOOD_MAP_RESTRICTION;
    },
    get EC_EXPORT_FORMAT () {
        return EC_EXPORT_FORMAT;
    },
    get EC_REVIEW_STATUS () {
        return EC_REVIEW_STATUS;
    },
    get EFFECTIVE_LIKE_FIRM_TYPES () {
        return EFFECTIVE_LIKE_FIRM_TYPES;
    },
    get ELEVATION_DATUM () {
        return ELEVATION_DATUM;
    },
    get EMAIL_PREFERENCES () {
        return EMAIL_PREFERENCES;
    },
    get EXTENSION_FOR_QUERY_DESCRIPTION_EXPORT_FORMAT () {
        return EXTENSION_FOR_QUERY_DESCRIPTION_EXPORT_FORMAT;
    },
    get EXTRACT_GPKG_FIELDS_STATUS () {
        return EXTRACT_GPKG_FIELDS_STATUS;
    },
    get FEATURED_ITEM_ENTITY_TYPE () {
        return FEATURED_ITEM_ENTITY_TYPE;
    },
    get FEATURED_ITEM_LINK_TYPE () {
        return FEATURED_ITEM_LINK_TYPE;
    },
    get FEATURE_FLAG_NAME () {
        return FEATURE_FLAG_NAME;
    },
    get FEET_PER_METER () {
        return FEET_PER_METER;
    },
    get FEET_PER_MILE () {
        return FEET_PER_MILE;
    },
    get FEMA_ELEVATION_DATUMS () {
        return FEMA_ELEVATION_DATUMS;
    },
    get FEMA_FIRM_TYPES () {
        return FEMA_FIRM_TYPES;
    },
    get FIRM_FORERUNNER_KEYS () {
        return FIRM_FORERUNNER_KEYS;
    },
    get FIRM_IMPORT_JOB_ERROR_TYPE () {
        return FIRM_IMPORT_JOB_ERROR_TYPE;
    },
    get FIRM_SOURCE () {
        return FIRM_SOURCE;
    },
    get FIRM_TYPES () {
        return FIRM_TYPES;
    },
    get FIRM_WARNING_CATEGORIES () {
        return FIRM_WARNING_CATEGORIES;
    },
    get FLAGGED_REASONS () {
        return FLAGGED_REASONS;
    },
    get FLOOD_ZONES () {
        return FLOOD_ZONES;
    },
    get FLOOD_ZONE_AGGREGATORS () {
        return FLOOD_ZONE_AGGREGATORS;
    },
    get GENERIC_FORERUNNER_KEYS () {
        return GENERIC_FORERUNNER_KEYS;
    },
    get GEOCODE_ACCURACY_PROFILE () {
        return GEOCODE_ACCURACY_PROFILE;
    },
    get GEOMETRY_TYPE () {
        return GEOMETRY_TYPE;
    },
    get GEOM_CREATION_TYPE () {
        return GEOM_CREATION_TYPE;
    },
    get GRAPHQL_TO_POINT_MAP_ICON () {
        return GRAPHQL_TO_POINT_MAP_ICON;
    },
    get GroupRoleList () {
        return GroupRoleList;
    },
    get HELPSCOUT_BEACON_PAGE () {
        return HELPSCOUT_BEACON_PAGE;
    },
    get HELP_OPTION_REASON_CODE () {
        return HELP_OPTION_REASON_CODE;
    },
    get HORIZONTAL_DATUM () {
        return HORIZONTAL_DATUM;
    },
    get IMAGE_MIME_TYPES () {
        return IMAGE_MIME_TYPES;
    },
    get IMAGE_RECOVERY_S3KEY () {
        return IMAGE_RECOVERY_S3KEY;
    },
    get IMPROVEMENT_EXCLUSION_REASON () {
        return IMPROVEMENT_EXCLUSION_REASON;
    },
    get IMPROVEMENT_KINDS () {
        return IMPROVEMENT_KINDS;
    },
    get INFORMATION_REQUEST_STATUS () {
        return INFORMATION_REQUEST_STATUS;
    },
    get INFO_REQUEST_CONTACT_TYPES () {
        return INFO_REQUEST_CONTACT_TYPES;
    },
    get INFO_REQUEST_INFO_GIVEN () {
        return INFO_REQUEST_INFO_GIVEN;
    },
    get INFO_REQUEST_TYPES () {
        return INFO_REQUEST_TYPES;
    },
    get INTERNAL_APP_SUBDOMAIN () {
        return INTERNAL_APP_SUBDOMAIN;
    },
    get INTERNAL_CREATED_BY_TYPE () {
        return INTERNAL_CREATED_BY_TYPE;
    },
    get JOB_STATUS () {
        return JOB_STATUS;
    },
    get JURISDICTIONS () {
        return JURISDICTIONS;
    },
    get LIGHT_GRAY_BASE_MAP () {
        return LIGHT_GRAY_BASE_MAP;
    },
    get LIGHT_GRAY_BASE_MAP_URL () {
        return LIGHT_GRAY_BASE_MAP_URL;
    },
    get LOAD_ALL_DATA_DYNAMIC_TOP_LEVEL_KEYS () {
        return LOAD_ALL_DATA_DYNAMIC_TOP_LEVEL_KEYS;
    },
    get LOGOUT_REASON () {
        return LOGOUT_REASON;
    },
    get MAPPING_TYPE_MISMATCH_ERROR () {
        return MAPPING_TYPE_MISMATCH_ERROR;
    },
    get MAP_COMPONENTS () {
        return MAP_COMPONENTS;
    },
    get MAP_LAYER_PATTERNS () {
        return MAP_LAYER_PATTERNS;
    },
    get MAX_AMOUNT_FOR_INDIVIDUAL_EMAIL_SEND () {
        return MAX_AMOUNT_FOR_INDIVIDUAL_EMAIL_SEND;
    },
    get MAX_POSTGRES_COLUMN_NAME_LENGTH () {
        return MAX_POSTGRES_COLUMN_NAME_LENGTH;
    },
    get METERS_PER_MILE () {
        return METERS_PER_MILE;
    },
    get MIME_TYPE () {
        return MIME_TYPE;
    },
    get MIME_TYPES_TO_EXTENSIONS () {
        return MIME_TYPES_TO_EXTENSIONS;
    },
    get MOBILE_PLATFORM () {
        return MOBILE_PLATFORM;
    },
    get MULTIPART_UPLOAD_TYPE () {
        return MULTIPART_UPLOAD_TYPE;
    },
    get NON_MAPBOX_TILESET_ID () {
        return NON_MAPBOX_TILESET_ID;
    },
    get NUM_SEARCH_RESULTS () {
        return NUM_SEARCH_RESULTS;
    },
    get OBJECT_TYPE () {
        return OBJECT_TYPE;
    },
    get OFFLINE_PACK_FILES () {
        return OFFLINE_PACK_FILES;
    },
    get OFFLINE_PACK_STATUS () {
        return OFFLINE_PACK_STATUS;
    },
    get PARCEL_IMPORT_FREQUENCY () {
        return PARCEL_IMPORT_FREQUENCY;
    },
    get PARCEL_IMPORT_TASK_TYPE () {
        return PARCEL_IMPORT_TASK_TYPE;
    },
    get PASSWORD_RESET_REQUESTER_TYPE () {
        return PASSWORD_RESET_REQUESTER_TYPE;
    },
    get PASSWORD_VALIDATION_ERROR_CODE () {
        return PASSWORD_VALIDATION_ERROR_CODE;
    },
    get PDA_WARNING_CODES () {
        return PDA_WARNING_CODES;
    },
    get PDF_MAPPING_TYPE () {
        return PDF_MAPPING_TYPE;
    },
    get PERMIT_ISSUE_TYPE () {
        return PERMIT_ISSUE_TYPE;
    },
    get PERMIT_TYPE () {
        return PERMIT_TYPE;
    },
    get POINT_MAP_ICON () {
        return POINT_MAP_ICON;
    },
    get POINT_MAP_ICON_GRAPHQL () {
        return POINT_MAP_ICON_GRAPHQL;
    },
    get POINT_MAP_ICON_TO_GRAPHQL () {
        return POINT_MAP_ICON_TO_GRAPHQL;
    },
    get PRESAVED_QUERY_NAMES () {
        return PRESAVED_QUERY_NAMES;
    },
    get PROJECT_TRACKING () {
        return PROJECT_TRACKING;
    },
    get PROPERTY_ADJUSTMENT_OPERATOR () {
        return PROPERTY_ADJUSTMENT_OPERATOR;
    },
    get PROPERTY_ATTRIBUTE_NAMES () {
        return PROPERTY_ATTRIBUTE_NAMES;
    },
    get PROPERTY_ATTRIBUTE_NAME_ALREADY_EXISTS_ERROR () {
        return PROPERTY_ATTRIBUTE_NAME_ALREADY_EXISTS_ERROR;
    },
    get PROPERTY_ATTRIBUTE_SOURCE () {
        return PROPERTY_ATTRIBUTE_SOURCE;
    },
    get PROPERTY_ATTRIBUTE_SOURCE_LABEL_MAP () {
        return PROPERTY_ATTRIBUTE_SOURCE_LABEL_MAP;
    },
    get PROPERTY_FORERUNNER_KEYS () {
        return PROPERTY_FORERUNNER_KEYS;
    },
    get PROPERTY_INFORMATION_SECTION_CODE () {
        return PROPERTY_INFORMATION_SECTION_CODE;
    },
    get PROPERTY_OBJECT_LABEL () {
        return PROPERTY_OBJECT_LABEL;
    },
    get PROPERTY_WARNING_CODE () {
        return PROPERTY_WARNING_CODE;
    },
    get PROPERTY_WARNING_GROUP () {
        return PROPERTY_WARNING_GROUP;
    },
    get PROPERTY_WARNING_SEVERITY () {
        return PROPERTY_WARNING_SEVERITY;
    },
    get PUBLIC_CERTIFICATE_UPLOAD_STATUS () {
        return PUBLIC_CERTIFICATE_UPLOAD_STATUS;
    },
    get PUBLIC_USER_SIGNUP_ERROR_CODE () {
        return PUBLIC_USER_SIGNUP_ERROR_CODE;
    },
    get PUBLIC_USER_STATUS () {
        return PUBLIC_USER_STATUS;
    },
    get PUBLIC_USER_STATUS_TO_TEXT () {
        return PUBLIC_USER_STATUS_TO_TEXT;
    },
    get QUERY_DESCRIPTION_EXPORT_FORMAT () {
        return QUERY_DESCRIPTION_EXPORT_FORMAT;
    },
    get RASTER_LAYER_SECTION () {
        return RASTER_LAYER_SECTION;
    },
    get RASTER_SOURCE_TYPE () {
        return RASTER_SOURCE_TYPE;
    },
    get RASTER_UNITS_SIGNIFIER () {
        return RASTER_UNITS_SIGNIFIER;
    },
    get RASTER_UNIT_OF_MEASUREMENT () {
        return RASTER_UNIT_OF_MEASUREMENT;
    },
    get REPETITIVE_LOSS_IMPORT_ISSUE () {
        return REPETITIVE_LOSS_IMPORT_ISSUE;
    },
    get REQUEST_ID_HEADER () {
        return REQUEST_ID_HEADER;
    },
    get RESET_PASSWORD_ERROR_CODE () {
        return RESET_PASSWORD_ERROR_CODE;
    },
    get ROLE_TYPE () {
        return ROLE_TYPE;
    },
    get ROW_SELECTION_MODE () {
        return ROW_SELECTION_MODE;
    },
    get RULE_DEFINITION_TYPE () {
        return RULE_DEFINITION_TYPE;
    },
    get RULE_FILTER_TYPE () {
        return RULE_FILTER_TYPE;
    },
    get RULE_MAP_FILTER_TYPE () {
        return RULE_MAP_FILTER_TYPE;
    },
    get RepetitiveLossIssueList () {
        return RepetitiveLossIssueList;
    },
    get SAME_RULE_NAME_ERROR () {
        return SAME_RULE_NAME_ERROR;
    },
    get SANITIZED_SAVED_VIEW_FORMATS () {
        return SANITIZED_SAVED_VIEW_FORMATS;
    },
    get SATELLITE_BASE_MAP () {
        return SATELLITE_BASE_MAP;
    },
    get SATELLITE_BASE_MAP_URL () {
        return SATELLITE_BASE_MAP_URL;
    },
    get SAVED_VIEW_EXPORT_DESTINATION () {
        return SAVED_VIEW_EXPORT_DESTINATION;
    },
    get SEARCH_CATEGORY () {
        return SEARCH_CATEGORY;
    },
    get SEARCH_RESULT_TYPE () {
        return SEARCH_RESULT_TYPE;
    },
    get SISD_STATUS () {
        return SISD_STATUS;
    },
    get SSO_ERROR_CODE () {
        return SSO_ERROR_CODE;
    },
    get STATES () {
        return STATES;
    },
    get SUBMISSION_CATEGORY () {
        return SUBMISSION_CATEGORY;
    },
    get SUBMISSION_EXPORT_FORMAT () {
        return SUBMISSION_EXPORT_FORMAT;
    },
    get SUBMISSION_STATUS () {
        return SUBMISSION_STATUS;
    },
    get SUBMISSION_TAB () {
        return SUBMISSION_TAB;
    },
    get SUBMISSION_TYPE_MODULE () {
        return SUBMISSION_TYPE_MODULE;
    },
    get SUPPORTED_FORM_YEARS () {
        return SUPPORTED_FORM_YEARS;
    },
    get SUPPORTED_LANGUAGES () {
        return SUPPORTED_LANGUAGES;
    },
    get SUPPORT_EMAIL () {
        return SUPPORT_EMAIL;
    },
    get SYNTHETIC_FLOOD_ZONES () {
        return SYNTHETIC_FLOOD_ZONES;
    },
    get SYSTEM_OF_MEASUREMENT () {
        return SYSTEM_OF_MEASUREMENT;
    },
    get TABLE_SUBSET_TYPE () {
        return TABLE_SUBSET_TYPE;
    },
    get TAG_DISPLAY () {
        return TAG_DISPLAY;
    },
    get TASK_ASSIGNEE_TYPE () {
        return TASK_ASSIGNEE_TYPE;
    },
    get TASK_RECORD_INTENTION () {
        return TASK_RECORD_INTENTION;
    },
    get TASK_STATUS () {
        return TASK_STATUS;
    },
    get THIRD_PARTY_SYSTEM_TYPE () {
        return THIRD_PARTY_SYSTEM_TYPE;
    },
    get TRANSCRIPTION_TASK_PRIORITY () {
        return TRANSCRIPTION_TASK_PRIORITY;
    },
    get TRANSCRIPTION_TASK_TYPE () {
        return TRANSCRIPTION_TASK_TYPE;
    },
    get UNIT_OF_MEASUREMENT () {
        return UNIT_OF_MEASUREMENT;
    },
    get USER_AUTH_METHOD () {
        return USER_AUTH_METHOD;
    },
    get USER_LOGIN_ERROR_CODE () {
        return USER_LOGIN_ERROR_CODE;
    },
    get US_EAST_2 () {
        return US_EAST_2;
    },
    get UserFriendlyCertificateStatus () {
        return UserFriendlyCertificateStatus;
    },
    get V2_PIPELINE_STATUS () {
        return V2_PIPELINE_STATUS;
    },
    get VALIDATION_STATUS () {
        return VALIDATION_STATUS;
    },
    get VIDEO_MIME_TYPES () {
        return VIDEO_MIME_TYPES;
    },
    get WARNING_CATEGORIES () {
        return WARNING_CATEGORIES;
    },
    get WARNING_SEVERITY () {
        return WARNING_SEVERITY;
    },
    get WEB_REQUIRED_PASSWORD_RESET_MESSAGE () {
        return WEB_REQUIRED_PASSWORD_RESET_MESSAGE;
    },
    get WORKFLOW_DEFINITION_STATUS () {
        return WORKFLOW_DEFINITION_STATUS;
    },
    get WORKFLOW_STATUS () {
        return WORKFLOW_STATUS;
    },
    get WORKFLOW_STATUS_MODE () {
        return WORKFLOW_STATUS_MODE;
    },
    get WORKFLOW_STEP_MANUAL_STATUS () {
        return WORKFLOW_STEP_MANUAL_STATUS;
    },
    get WORKFLOW_STEP_STATUS () {
        return WORKFLOW_STEP_STATUS;
    },
    get firmDocGenOptions () {
        return firmDocGenOptions;
    },
    get genericDocGenOptions () {
        return genericDocGenOptions;
    },
    get isSsoErrorCode () {
        return isSsoErrorCode;
    },
    get modelNamesToColumnNames () {
        return modelNamesToColumnNames;
    },
    get propertyDocGenOptions () {
        return propertyDocGenOptions;
    }
});
const STATES = [
    {
        name: "Alabama",
        abbreviation: "AL",
        fips: "01"
    },
    {
        name: "Alaska",
        abbreviation: "AK",
        fips: "02"
    },
    {
        name: "American Samoa",
        abbreviation: "AS",
        fips: "60"
    },
    {
        name: "Arizona",
        abbreviation: "AZ",
        fips: "04"
    },
    {
        name: "Arkansas",
        abbreviation: "AR",
        fips: "05"
    },
    {
        name: "California",
        abbreviation: "CA",
        fips: "06"
    },
    {
        name: "Colorado",
        abbreviation: "CO",
        fips: "08"
    },
    {
        name: "Connecticut",
        abbreviation: "CT",
        fips: "09"
    },
    {
        name: "Delaware",
        abbreviation: "DE",
        fips: "10"
    },
    {
        name: "District Of Columbia",
        abbreviation: "DC",
        fips: "11"
    },
    {
        name: "Federated States Of Micronesia",
        abbreviation: "FM",
        fips: "64"
    },
    {
        name: "Florida",
        abbreviation: "FL",
        fips: "12"
    },
    {
        name: "Georgia",
        abbreviation: "GA",
        fips: "13"
    },
    {
        name: "Guam",
        abbreviation: "GU",
        fips: "14"
    },
    {
        name: "Hawaii",
        abbreviation: "HI",
        fips: "15"
    },
    {
        name: "Idaho",
        abbreviation: "ID",
        fips: "16"
    },
    {
        name: "Illinois",
        abbreviation: "IL",
        fips: "17"
    },
    {
        name: "Indiana",
        abbreviation: "IN",
        fips: "18"
    },
    {
        name: "Iowa",
        abbreviation: "IA",
        fips: "19"
    },
    {
        name: "Kansas",
        abbreviation: "KS",
        fips: "20"
    },
    {
        name: "Kentucky",
        abbreviation: "KY",
        fips: "21"
    },
    {
        name: "Louisiana",
        abbreviation: "LA",
        fips: "22"
    },
    {
        name: "Maine",
        abbreviation: "ME",
        fips: "23"
    },
    {
        name: "Marshall Islands",
        abbreviation: "MH",
        fips: "68"
    },
    {
        name: "Maryland",
        abbreviation: "MD",
        fips: "24"
    },
    {
        name: "Massachusetts",
        abbreviation: "MA",
        fips: "25"
    },
    {
        name: "Michigan",
        abbreviation: "MI",
        fips: "26"
    },
    {
        name: "Minnesota",
        abbreviation: "MN",
        fips: "27"
    },
    {
        name: "Mississippi",
        abbreviation: "MS",
        fips: "28"
    },
    {
        name: "Missouri",
        abbreviation: "MO",
        fips: "29"
    },
    {
        name: "Montana",
        abbreviation: "MT",
        fips: "30"
    },
    {
        name: "Nebraska",
        abbreviation: "NE",
        fips: "31"
    },
    {
        name: "Nevada",
        abbreviation: "NV",
        fips: "32"
    },
    {
        name: "New Hampshire",
        abbreviation: "NH",
        fips: "33"
    },
    {
        name: "New Jersey",
        abbreviation: "NJ",
        fips: "34"
    },
    {
        name: "New Mexico",
        abbreviation: "NM",
        fips: "35"
    },
    {
        name: "New York",
        abbreviation: "NY",
        fips: "36"
    },
    {
        name: "North Carolina",
        abbreviation: "NC",
        fips: "37"
    },
    {
        name: "North Dakota",
        abbreviation: "ND",
        fips: "38"
    },
    {
        name: "Northern Mariana Islands",
        abbreviation: "MP",
        fips: "69"
    },
    {
        name: "Ohio",
        abbreviation: "OH",
        fips: "39"
    },
    {
        name: "Oklahoma",
        abbreviation: "OK",
        fips: "40"
    },
    {
        name: "Oregon",
        abbreviation: "OR",
        fips: "41"
    },
    {
        name: "Palau",
        abbreviation: "PW",
        fips: "70"
    },
    {
        name: "Pennsylvania",
        abbreviation: "PA",
        fips: "42"
    },
    {
        name: "Puerto Rico",
        abbreviation: "PR",
        fips: "43"
    },
    {
        name: "Rhode Island",
        abbreviation: "RI",
        fips: "44"
    },
    {
        name: "South Carolina",
        abbreviation: "SC",
        fips: "45"
    },
    {
        name: "South Dakota",
        abbreviation: "SD",
        fips: "46"
    },
    {
        name: "Tennessee",
        abbreviation: "TN",
        fips: "47"
    },
    {
        name: "Texas",
        abbreviation: "TX",
        fips: "48"
    },
    {
        name: "Utah",
        abbreviation: "UT",
        fips: "49"
    },
    {
        name: "Vermont",
        abbreviation: "VT",
        fips: "50"
    },
    {
        name: "Virgin Islands",
        abbreviation: "VI",
        fips: "52"
    },
    {
        name: "Virginia",
        abbreviation: "VA",
        fips: "51"
    },
    {
        name: "Washington",
        abbreviation: "WA",
        fips: "53"
    },
    {
        name: "West Virginia",
        abbreviation: "WV",
        fips: "54"
    },
    {
        name: "Wisconsin",
        abbreviation: "WI",
        fips: "55"
    },
    {
        name: "Wyoming",
        abbreviation: "WY",
        fips: "56"
    }
];
const SUPPORTED_FORM_YEARS = [
    1982,
    1984,
    1987,
    1990,
    1993,
    1996,
    1999,
    2002,
    2005,
    2009,
    2012,
    2015,
    2018,
    2022,
    2026
];
var PARCEL_IMPORT_FREQUENCY = /*#__PURE__*/ function(PARCEL_IMPORT_FREQUENCY) {
    PARCEL_IMPORT_FREQUENCY["DAILY"] = "daily";
    PARCEL_IMPORT_FREQUENCY["WEEKLY"] = "weekly";
    PARCEL_IMPORT_FREQUENCY["BIWEEKLY"] = "biweekly";
    PARCEL_IMPORT_FREQUENCY["MONTHLY"] = "monthly";
    return PARCEL_IMPORT_FREQUENCY;
}({});
var ARCGIS_EXPORT_FREQUENCY = /*#__PURE__*/ function(ARCGIS_EXPORT_FREQUENCY) {
    ARCGIS_EXPORT_FREQUENCY["WEEKLY"] = "weekly";
    ARCGIS_EXPORT_FREQUENCY["DAILY"] = "daily";
    ARCGIS_EXPORT_FREQUENCY["HOURLY"] = "hourly";
    ARCGIS_EXPORT_FREQUENCY["HALF_HOURLY"] = "half_hourly";
    return ARCGIS_EXPORT_FREQUENCY;
}({});
var COASTAL_A_DETERMINATION = /*#__PURE__*/ function(COASTAL_A_DETERMINATION) {
    COASTAL_A_DETERMINATION["DISABLED"] = "disabled";
    COASTAL_A_DETERMINATION["MANUAL"] = "manual";
    COASTAL_A_DETERMINATION["AUTOMATIC"] = "automatic";
    return COASTAL_A_DETERMINATION;
}({});
var INFO_REQUEST_TYPES = /*#__PURE__*/ function(INFO_REQUEST_TYPES) {
    INFO_REQUEST_TYPES["WEB"] = "web";
    INFO_REQUEST_TYPES["WALKIN"] = "walk-in";
    INFO_REQUEST_TYPES["PHONE"] = "phone";
    INFO_REQUEST_TYPES["WRITTEN"] = "written/email request";
    return INFO_REQUEST_TYPES;
}({});
var INFO_REQUEST_INFO_GIVEN = /*#__PURE__*/ function(INFO_REQUEST_INFO_GIVEN) {
    INFO_REQUEST_INFO_GIVEN["VERBAL"] = "verbally";
    INFO_REQUEST_INFO_GIVEN["HANDOUT"] = "handout";
    INFO_REQUEST_INFO_GIVEN["EMAIL"] = "email";
    return INFO_REQUEST_INFO_GIVEN;
}({});
var INFO_REQUEST_CONTACT_TYPES = /*#__PURE__*/ function(INFO_REQUEST_CONTACT_TYPES) {
    INFO_REQUEST_CONTACT_TYPES["HOMEOWNER"] = "homeowner";
    INFO_REQUEST_CONTACT_TYPES["PROPERTY_OWNER"] = "property_owner";
    INFO_REQUEST_CONTACT_TYPES["RENTER"] = "renter";
    INFO_REQUEST_CONTACT_TYPES["SURVEYOR"] = "surveyor";
    INFO_REQUEST_CONTACT_TYPES["CONTRACTOR"] = "contractor";
    INFO_REQUEST_CONTACT_TYPES["ARCHITECT"] = "architect";
    INFO_REQUEST_CONTACT_TYPES["INSURANCE_AGENT"] = "insurance_agent";
    INFO_REQUEST_CONTACT_TYPES["REALTOR"] = "realtor";
    INFO_REQUEST_CONTACT_TYPES["BUYER"] = "buyer";
    INFO_REQUEST_CONTACT_TYPES["OTHER"] = "other";
    return INFO_REQUEST_CONTACT_TYPES;
}({});
var FLOOD_ZONES = /*#__PURE__*/ function(FLOOD_ZONES) {
    FLOOD_ZONES["VE"] = "VE";
    FLOOD_ZONES["AO"] = "AO";
    FLOOD_ZONES["AE"] = "AE";
    FLOOD_ZONES["A99"] = "A99";
    FLOOD_ZONES["AR"] = "AR";
    FLOOD_ZONES["AR/AO"] = "AR/AO";
    FLOOD_ZONES["V"] = "V";
    FLOOD_ZONES["X"] = "X";
    FLOOD_ZONES["X500"] = "X500";
    FLOOD_ZONES["D"] = "D";
    FLOOD_ZONES["B"] = "B";
    FLOOD_ZONES["C"] = "C";
    FLOOD_ZONES["AH"] = "AH";
    FLOOD_ZONES["A"] = "A";
    FLOOD_ZONES["A1"] = "A1";
    FLOOD_ZONES["A2"] = "A2";
    FLOOD_ZONES["A3"] = "A3";
    FLOOD_ZONES["A4"] = "A4";
    FLOOD_ZONES["A5"] = "A5";
    FLOOD_ZONES["A6"] = "A6";
    FLOOD_ZONES["A7"] = "A7";
    FLOOD_ZONES["A8"] = "A8";
    FLOOD_ZONES["A9"] = "A9";
    FLOOD_ZONES["A10"] = "A10";
    FLOOD_ZONES["A11"] = "A11";
    FLOOD_ZONES["A12"] = "A12";
    FLOOD_ZONES["A13"] = "A13";
    FLOOD_ZONES["A14"] = "A14";
    FLOOD_ZONES["A15"] = "A15";
    FLOOD_ZONES["A16"] = "A16";
    FLOOD_ZONES["A17"] = "A17";
    FLOOD_ZONES["A18"] = "A18";
    FLOOD_ZONES["A19"] = "A19";
    FLOOD_ZONES["A20"] = "A20";
    FLOOD_ZONES["A21"] = "A21";
    FLOOD_ZONES["A22"] = "A22";
    FLOOD_ZONES["A23"] = "A23";
    FLOOD_ZONES["A24"] = "A24";
    FLOOD_ZONES["A25"] = "A25";
    FLOOD_ZONES["A26"] = "A26";
    FLOOD_ZONES["A27"] = "A27";
    FLOOD_ZONES["A28"] = "A28";
    FLOOD_ZONES["A29"] = "A29";
    FLOOD_ZONES["A30"] = "A30";
    FLOOD_ZONES["V1"] = "V1";
    FLOOD_ZONES["V2"] = "V2";
    FLOOD_ZONES["V3"] = "V3";
    FLOOD_ZONES["V4"] = "V4";
    FLOOD_ZONES["V5"] = "V5";
    FLOOD_ZONES["V6"] = "V6";
    FLOOD_ZONES["V7"] = "V7";
    FLOOD_ZONES["V8"] = "V8";
    FLOOD_ZONES["V9"] = "V9";
    FLOOD_ZONES["V10"] = "V10";
    FLOOD_ZONES["V11"] = "V11";
    FLOOD_ZONES["V12"] = "V12";
    FLOOD_ZONES["V13"] = "V13";
    FLOOD_ZONES["V14"] = "V14";
    FLOOD_ZONES["V15"] = "V15";
    FLOOD_ZONES["V16"] = "V16";
    FLOOD_ZONES["V17"] = "V17";
    FLOOD_ZONES["V18"] = "V18";
    FLOOD_ZONES["V19"] = "V19";
    FLOOD_ZONES["V20"] = "V20";
    FLOOD_ZONES["V21"] = "V21";
    FLOOD_ZONES["V22"] = "V22";
    FLOOD_ZONES["V23"] = "V23";
    FLOOD_ZONES["V24"] = "V24";
    FLOOD_ZONES["V25"] = "V25";
    FLOOD_ZONES["V26"] = "V26";
    FLOOD_ZONES["V27"] = "V27";
    FLOOD_ZONES["V28"] = "V28";
    FLOOD_ZONES["V29"] = "V29";
    FLOOD_ZONES["V30"] = "V30";
    FLOOD_ZONES["X500LOMC"] = "X500 (LOMC)";
    FLOOD_ZONES["XLOMC"] = "X (LOMC)";
    FLOOD_ZONES["OPEN WATER"] = "OPEN WATER";
    return FLOOD_ZONES;
}({});
var FLOOD_ZONE_AGGREGATORS = /*#__PURE__*/ function(FLOOD_ZONE_AGGREGATORS) {
    FLOOD_ZONE_AGGREGATORS["ALL_ZONES"] = "All zones";
    FLOOD_ZONE_AGGREGATORS["NO_ZONES"] = "No zones";
    FLOOD_ZONE_AGGREGATORS["SFHA"] = "SFHA";
    return FLOOD_ZONE_AGGREGATORS;
}({});
const SYNTHETIC_FLOOD_ZONES = [
    "X500 (LOMC)",
    "X (LOMC)"
];
var CERTIFICATE_UPLOAD_STATUS = /*#__PURE__*/ function(CERTIFICATE_UPLOAD_STATUS) {
    CERTIFICATE_UPLOAD_STATUS["PROCESSING"] = "processing";
    CERTIFICATE_UPLOAD_STATUS["NEEDS_TEXT_EXTRACTION"] = "needs_text_extraction";
    CERTIFICATE_UPLOAD_STATUS["EXTRACTING_TEXT"] = "extracting_text";
    CERTIFICATE_UPLOAD_STATUS["TEXT_EXTRACTION_COMPLETE"] = "text_extraction_complete";
    CERTIFICATE_UPLOAD_STATUS["EXTRACTING_VERSION"] = "extracting_version";
    CERTIFICATE_UPLOAD_STATUS["VERSION_EXTRACTION_COMPLETE"] = "version_extraction_complete";
    CERTIFICATE_UPLOAD_STATUS["EXTRACTING_DATA"] = "extracting_data";
    CERTIFICATE_UPLOAD_STATUS["DATA_EXTRACTION_COMPLETE"] = "data_extraction_complete";
    CERTIFICATE_UPLOAD_STATUS["VALIDATING"] = "validating";
    CERTIFICATE_UPLOAD_STATUS["VALIDATED"] = "validated";
    CERTIFICATE_UPLOAD_STATUS["FAILED_VALIDATION"] = "failed_validation";
    CERTIFICATE_UPLOAD_STATUS["CREATING_CERTIFICATE"] = "creating_certificate";
    CERTIFICATE_UPLOAD_STATUS["COMPLETED"] = "completed";
    CERTIFICATE_UPLOAD_STATUS["CANCELED"] = "canceled";
    CERTIFICATE_UPLOAD_STATUS["VALIDATING_PROPERTY"] = "validating_property";
    CERTIFICATE_UPLOAD_STATUS["FAILED_PROPERTY_VALIDATION"] = "failed_property_validation";
    CERTIFICATE_UPLOAD_STATUS["FAILED_PROPERTY_VALIDATION_V2"] = "failed_property_validation_v2";
    CERTIFICATE_UPLOAD_STATUS["PROPERTY_VALIDATED"] = "property_validated";
    CERTIFICATE_UPLOAD_STATUS["CERTIFICATE_PIPELINE_V2"] = "processing_v2";
    return CERTIFICATE_UPLOAD_STATUS;
}({});
var PUBLIC_CERTIFICATE_UPLOAD_STATUS = /*#__PURE__*/ function(PUBLIC_CERTIFICATE_UPLOAD_STATUS) {
    PUBLIC_CERTIFICATE_UPLOAD_STATUS["CANCELED"] = "canceled";
    PUBLIC_CERTIFICATE_UPLOAD_STATUS["COMPLETED"] = "completed";
    PUBLIC_CERTIFICATE_UPLOAD_STATUS["PROCESSING"] = "processing";
    PUBLIC_CERTIFICATE_UPLOAD_STATUS["NEEDS_LOCATION"] = "needs_location";
    return PUBLIC_CERTIFICATE_UPLOAD_STATUS;
}({});
const UserFriendlyCertificateStatus = {
    ["canceled"]: "Unprocessed",
    ["completed"]: "Complete",
    ["processing"]: "In progress",
    ["needs_location"]: "Needs location"
};
var CERTIFICATE_VERSION = /*#__PURE__*/ function(CERTIFICATE_VERSION) {
    CERTIFICATE_VERSION["GROUP_1"] = "group_1";
    CERTIFICATE_VERSION["GROUP_2"] = "group_2";
    CERTIFICATE_VERSION["GROUP_3"] = "group_3";
    CERTIFICATE_VERSION["GROUP_4"] = "group_4";
    CERTIFICATE_VERSION["GROUP_5"] = "group_5";
    CERTIFICATE_VERSION["GROUP_6"] = "group_6";
    CERTIFICATE_VERSION["GROUP_7"] = "group_7";
    CERTIFICATE_VERSION["GROUP_8"] = "group_8";
    return CERTIFICATE_VERSION;
}({});
var CERTIFICATE_TYPE = /*#__PURE__*/ function(CERTIFICATE_TYPE) {
    CERTIFICATE_TYPE["REGULAR"] = "regular";
    CERTIFICATE_TYPE["HISTORIC"] = "historic";
    return CERTIFICATE_TYPE;
}({});
var BUILDING_USE = /*#__PURE__*/ function(BUILDING_USE) {
    BUILDING_USE["RESIDENTIAL"] = "residential";
    BUILDING_USE["NON_RESIDENTIAL"] = "non_residential";
    BUILDING_USE["ADDITION"] = "addition";
    BUILDING_USE["ACCESSORY"] = "accessory";
    BUILDING_USE["COMMERCIAL"] = "commercial";
    BUILDING_USE["HOTEL"] = "hotel";
    BUILDING_USE["OTHER"] = "other";
    return BUILDING_USE;
}({});
var BUILDING_ELEVATION_SOURCE = /*#__PURE__*/ function(BUILDING_ELEVATION_SOURCE) {
    BUILDING_ELEVATION_SOURCE["CONSTRUCTION_DRAWINGS"] = "construction_drawings";
    BUILDING_ELEVATION_SOURCE["BUILDING_UNDER_CONSTRUCTION"] = "building_under_construction";
    BUILDING_ELEVATION_SOURCE["FINISHED_CONSTRUCTION"] = "finished_construction";
    return BUILDING_ELEVATION_SOURCE;
}({});
var ELEVATION_DATUM = /*#__PURE__*/ function(ELEVATION_DATUM) {
    ELEVATION_DATUM["NGVD_1929"] = "ngvd_1929";
    ELEVATION_DATUM["NAVD_1988"] = "navd_1988";
    ELEVATION_DATUM["PRVD02"] = "prvd02";
    ELEVATION_DATUM["LTD"] = "ltd";
    ELEVATION_DATUM["OTHER"] = "other";
    return ELEVATION_DATUM;
}({});
const FEMA_ELEVATION_DATUMS = Object.values(ELEVATION_DATUM).filter((datum)=>datum !== "other");
var HORIZONTAL_DATUM = /*#__PURE__*/ function(HORIZONTAL_DATUM) {
    HORIZONTAL_DATUM["NAD_1927"] = "nad_1927";
    HORIZONTAL_DATUM["NAD_1983"] = "nad_1983";
    HORIZONTAL_DATUM["WGS_84"] = "wgs_84";
    return HORIZONTAL_DATUM;
}({});
var BASE_FLOOD_ELEVATION_SOURCE = /*#__PURE__*/ function(BASE_FLOOD_ELEVATION_SOURCE) {
    BASE_FLOOD_ELEVATION_SOURCE["FIS_PROFILE"] = "fis_profile";
    BASE_FLOOD_ELEVATION_SOURCE["FIRM"] = "firm";
    BASE_FLOOD_ELEVATION_SOURCE["COMMUNITY_DETERMINED"] = "community_determined";
    BASE_FLOOD_ELEVATION_SOURCE["OTHER"] = "other";
    return BASE_FLOOD_ELEVATION_SOURCE;
}({});
var TRANSCRIPTION_TASK_TYPE = /*#__PURE__*/ function(TRANSCRIPTION_TASK_TYPE) {
    TRANSCRIPTION_TASK_TYPE["VERSION_EXTRACTION"] = "version_extraction";
    TRANSCRIPTION_TASK_TYPE["FULL_DATA_EXTRACTION"] = "full_data_extraction";
    TRANSCRIPTION_TASK_TYPE["VALIDATION"] = "validation";
    TRANSCRIPTION_TASK_TYPE["GEOCODING"] = "geocoding";
    return TRANSCRIPTION_TASK_TYPE;
}({});
var IMPROVEMENT_KINDS = /*#__PURE__*/ function(IMPROVEMENT_KINDS) {
    IMPROVEMENT_KINDS["IMPROVEMENT"] = "improvement";
    IMPROVEMENT_KINDS["DAMAGE"] = "damage";
    return IMPROVEMENT_KINDS;
}({});
const BUILDING_DIAGRAM_NUMBERS = [
    "1",
    "1A",
    "1B",
    "2",
    "2A",
    "2B",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
var PROJECT_TRACKING = /*#__PURE__*/ function(PROJECT_TRACKING) {
    PROJECT_TRACKING["PER_PROJECT"] = "per_project";
    PROJECT_TRACKING["CUMULATIVE"] = "cumulative";
    PROJECT_TRACKING["BUILDING_LIFETIME"] = "building_lifetime";
    PROJECT_TRACKING["CALENDAR_YEAR"] = "calendar_year";
    return PROJECT_TRACKING;
}({});
var FIRM_TYPES = /*#__PURE__*/ function(FIRM_TYPES) {
    FIRM_TYPES["PRELIMINARY"] = "preliminary";
    FIRM_TYPES["EFFECTIVE"] = "effective";
    FIRM_TYPES["HISTORIC_EFFECTIVE"] = "historic_effective";
    FIRM_TYPES["OTHER"] = "other";
    return FIRM_TYPES;
}({});
var JURISDICTIONS = /*#__PURE__*/ function(JURISDICTIONS) {
    JURISDICTIONS["NFIP"] = "nfip";
    JURISDICTIONS["REGULATORY"] = "regulatory";
    return JURISDICTIONS;
}({});
var DEFAULT_PROPERTY_FIRM = /*#__PURE__*/ function(DEFAULT_PROPERTY_FIRM) {
    DEFAULT_PROPERTY_FIRM["ACCOUNT_DEFAULT_FIRM"] = "account_default_firm";
    DEFAULT_PROPERTY_FIRM["PROPERTY_REGULATORY_FIRM"] = "property_regulatory_firm";
    return DEFAULT_PROPERTY_FIRM;
}({});
var SISD_STATUS = /*#__PURE__*/ function(SISD_STATUS) {
    SISD_STATUS["UNDER"] = "under";
    SISD_STATUS["CLOSE"] = "close";
    SISD_STATUS["OVER"] = "over";
    return SISD_STATUS;
}({});
var WARNING_SEVERITY = /*#__PURE__*/ function(WARNING_SEVERITY) {
    WARNING_SEVERITY["LOW"] = "low";
    WARNING_SEVERITY["MEDIUM"] = "medium";
    WARNING_SEVERITY["HIGH"] = "high";
    return WARNING_SEVERITY;
}({});
var PROPERTY_ADJUSTMENT_OPERATOR = /*#__PURE__*/ function(PROPERTY_ADJUSTMENT_OPERATOR) {
    PROPERTY_ADJUSTMENT_OPERATOR["MULTIPLICATION"] = "multiplication";
    PROPERTY_ADJUSTMENT_OPERATOR["DIVISION"] = "division";
    return PROPERTY_ADJUSTMENT_OPERATOR;
}({});
var PERMIT_TYPE = /*#__PURE__*/ function(PERMIT_TYPE) {
    PERMIT_TYPE["NEW_CONSTRUCTION"] = "new_construction";
    PERMIT_TYPE["SUBSTANTIAL_IMPROVEMENT"] = "substantial_improvement";
    PERMIT_TYPE["SUBSTANTIAL_DAMAGE"] = "substantial_damage";
    PERMIT_TYPE["COMBINATION"] = "combination";
    PERMIT_TYPE["OTHER"] = "other";
    return PERMIT_TYPE;
}({});
var FIRM_SOURCE = /*#__PURE__*/ function(FIRM_SOURCE) {
    FIRM_SOURCE["FEMA"] = "fema";
    FIRM_SOURCE["GEOJSON"] = "geojson";
    return FIRM_SOURCE;
}({});
var EMAIL_PREFERENCES = /*#__PURE__*/ function(EMAIL_PREFERENCES) {
    EMAIL_PREFERENCES["EC_ERROR_DETECTION"] = "ec_error_detection";
    return EMAIL_PREFERENCES;
}({});
var DESIGN_FLOOD_ELEVATION_TYPE = /*#__PURE__*/ function(DESIGN_FLOOD_ELEVATION_TYPE) {
    DESIGN_FLOOD_ELEVATION_TYPE["CUSTOM"] = "custom";
    DESIGN_FLOOD_ELEVATION_TYPE["DEFAULT"] = "default";
    return DESIGN_FLOOD_ELEVATION_TYPE;
}({});
var CREATED_BY_TYPE = /*#__PURE__*/ function(CREATED_BY_TYPE) {
    CREATED_BY_TYPE["USER"] = "user";
    CREATED_BY_TYPE["ADMIN"] = "admin";
    CREATED_BY_TYPE["GUEST"] = "guest";
    CREATED_BY_TYPE["API_KEY"] = "apiKey";
    CREATED_BY_TYPE["PUBLIC_USER"] = "publicUser";
    return CREATED_BY_TYPE;
}({});
var INTERNAL_CREATED_BY_TYPE = /*#__PURE__*/ function(INTERNAL_CREATED_BY_TYPE) {
    INTERNAL_CREATED_BY_TYPE["USER"] = "user";
    INTERNAL_CREATED_BY_TYPE["ADMIN"] = "admin";
    return INTERNAL_CREATED_BY_TYPE;
}({});
var ACCESS_CONTROL_ENTITY_TYPE = /*#__PURE__*/ function(ACCESS_CONTROL_ENTITY_TYPE) {
    ACCESS_CONTROL_ENTITY_TYPE["USER"] = "user";
    ACCESS_CONTROL_ENTITY_TYPE["PUBLIC_USER"] = "publicUser";
    ACCESS_CONTROL_ENTITY_TYPE["PUBLIC_USER_INVITE"] = "publicUserInvite";
    ACCESS_CONTROL_ENTITY_TYPE["USER_GROUP"] = "userGroup";
    return ACCESS_CONTROL_ENTITY_TYPE;
}({});
var ACCESS_CONTROL_RESOURCE_TYPE = /*#__PURE__*/ function(ACCESS_CONTROL_RESOURCE_TYPE) {
    ACCESS_CONTROL_RESOURCE_TYPE["SUBMISSION"] = "submission";
    ACCESS_CONTROL_RESOURCE_TYPE["SUBMISSION_TYPE"] = "submissionType";
    ACCESS_CONTROL_RESOURCE_TYPE["WORKFLOW_STEP"] = "workflowStep";
    ACCESS_CONTROL_RESOURCE_TYPE["WORKFLOW"] = "workflow";
    ACCESS_CONTROL_RESOURCE_TYPE["WORKFLOW_STEP_DEFINITION"] = "workflowStepDefinition";
    return ACCESS_CONTROL_RESOURCE_TYPE;
}({});
var GEOMETRY_TYPE = /*#__PURE__*/ function(GEOMETRY_TYPE) {
    GEOMETRY_TYPE["POINT"] = "point";
    GEOMETRY_TYPE["POLYGON"] = "polygon";
    return GEOMETRY_TYPE;
}({});
var CUSTOM_MAP_GEOMETRY_TYPE = /*#__PURE__*/ function(CUSTOM_MAP_GEOMETRY_TYPE) {
    CUSTOM_MAP_GEOMETRY_TYPE["POINT"] = "point";
    CUSTOM_MAP_GEOMETRY_TYPE["MULTI_POINT"] = "multi_point";
    CUSTOM_MAP_GEOMETRY_TYPE["LINE"] = "line";
    CUSTOM_MAP_GEOMETRY_TYPE["MULTI_LINE"] = "multi_line";
    CUSTOM_MAP_GEOMETRY_TYPE["POLYGON"] = "polygon";
    CUSTOM_MAP_GEOMETRY_TYPE["MULTI_POLYGON"] = "multi_polygon";
    return CUSTOM_MAP_GEOMETRY_TYPE;
}({});
var BASE_CUSTOM_MAP_GEOMETRY_TYPE = /*#__PURE__*/ function(BASE_CUSTOM_MAP_GEOMETRY_TYPE) {
    BASE_CUSTOM_MAP_GEOMETRY_TYPE["POINT"] = "point";
    BASE_CUSTOM_MAP_GEOMETRY_TYPE["LINE"] = "line";
    BASE_CUSTOM_MAP_GEOMETRY_TYPE["POLYGON"] = "polygon";
    return BASE_CUSTOM_MAP_GEOMETRY_TYPE;
}({});
var ACTIVITY_TARGET_TYPE = /*#__PURE__*/ function(ACTIVITY_TARGET_TYPE) {
    ACTIVITY_TARGET_TYPE["CERTIFICATE"] = "certificate";
    ACTIVITY_TARGET_TYPE["COMMENT"] = "comment";
    ACTIVITY_TARGET_TYPE["CUSTOM_MAP_GEOMETRY"] = "custom_map_geometry";
    ACTIVITY_TARGET_TYPE["DESIGN_FLOOD_ELEVATION"] = "design_flood_elevation";
    ACTIVITY_TARGET_TYPE["FIRM"] = "FIRM";
    ACTIVITY_TARGET_TYPE["LOG"] = "log";
    ACTIVITY_TARGET_TYPE["PROPERTY"] = "property";
    ACTIVITY_TARGET_TYPE["DOCUMENT_UPLOAD"] = "document_upload";
    ACTIVITY_TARGET_TYPE["BATCH_CERTIFICATE_UPLOAD"] = "batch_certificate_upload";
    ACTIVITY_TARGET_TYPE["PROPERTY_WARNING"] = "property_warning";
    ACTIVITY_TARGET_TYPE["PUBLIC_USER"] = "public_user";
    ACTIVITY_TARGET_TYPE["REPETITIVE_LOSS"] = "repetitive_loss";
    ACTIVITY_TARGET_TYPE["SUBMISSION"] = "submission";
    ACTIVITY_TARGET_TYPE["SAVED_VIEW"] = "saved_view";
    ACTIVITY_TARGET_TYPE["TASK"] = "task";
    ACTIVITY_TARGET_TYPE["WORKFLOW"] = "workflow";
    return ACTIVITY_TARGET_TYPE;
}({});
var ACTIVITY_TYPE = /*#__PURE__*/ function(ACTIVITY_TYPE) {
    ACTIVITY_TYPE["APPROVED"] = "approved";
    ACTIVITY_TYPE["CREATED"] = "created";
    ACTIVITY_TYPE["DENIED"] = "denied";
    ACTIVITY_TYPE["DELETED"] = "deleted";
    ACTIVITY_TYPE["DISPLAYED"] = "displayed";
    ACTIVITY_TYPE["EXCLUDED"] = "excluded";
    ACTIVITY_TYPE["HID"] = "hid";
    ACTIVITY_TYPE["INCLUDED"] = "included";
    ACTIVITY_TYPE["SHARED"] = "shared";
    ACTIVITY_TYPE["SUBMITTED"] = "submitted";
    ACTIVITY_TYPE["SUSPENDED"] = "suspended";
    ACTIVITY_TYPE["UNSUSPENDED"] = "unsuspended";
    ACTIVITY_TYPE["UPDATED"] = "updated";
    ACTIVITY_TYPE["UPLOADED"] = "uploaded";
    ACTIVITY_TYPE["VIEWED"] = "viewed";
    return ACTIVITY_TYPE;
}({});
var ROLE_TYPE = /*#__PURE__*/ function(ROLE_TYPE) {
    ROLE_TYPE["USER"] = "user";
    ROLE_TYPE["PUBLIC_USER"] = "publicUser";
    ROLE_TYPE["ADMIN"] = "admin";
    ROLE_TYPE["GUEST"] = "guest";
    return ROLE_TYPE;
}({});
const GroupRoleList = [
    "user",
    "publicUser",
    "admin"
];
var DOCUMENT_TYPE_NAME = /*#__PURE__*/ function(DOCUMENT_TYPE_NAME) {
    DOCUMENT_TYPE_NAME["ELEVATION_CERTIFICATE"] = "Elevation Certificate";
    DOCUMENT_TYPE_NAME["PROPERTY_IMAGE"] = "Property Image";
    DOCUMENT_TYPE_NAME["MILESTONE_INSPECTION_REPORT_PHASE_ONE"] = "Milestone inspection report phase 1";
    DOCUMENT_TYPE_NAME["MILESTONE_INSPECTION_REPORT_PHASE_TWO"] = "Milestone inspection report phase 2";
    DOCUMENT_TYPE_NAME["MILESTONE_INSPECTION_REPAIRS"] = "Milestone inspection repairs";
    DOCUMENT_TYPE_NAME["PA_PDA_DOCUMENTATION"] = "PA PDA Documentation";
    return DOCUMENT_TYPE_NAME;
}({});
var MIME_TYPE = /*#__PURE__*/ function(MIME_TYPE) {
    MIME_TYPE["PDF"] = "application/pdf";
    MIME_TYPE["JPG"] = "image/jpg";
    MIME_TYPE["JPEG"] = "image/jpeg";
    MIME_TYPE["PNG"] = "image/png";
    MIME_TYPE["JSON"] = "application/json";
    MIME_TYPE["GEOJSON"] = "application/geo+json";
    MIME_TYPE["GPKG"] = "application/geopackage+vnd.sqlite3";
    MIME_TYPE["CSV"] = "text/csv";
    MIME_TYPE["MP4"] = "video/mp4";
    MIME_TYPE["MOV"] = "video/quicktime";
    MIME_TYPE["ZIP"] = "application/zip";
    return MIME_TYPE;
}({});
const IMAGE_MIME_TYPES = [
    "image/jpg",
    "image/jpeg",
    "image/png"
];
const VIDEO_MIME_TYPES = [
    "video/mp4",
    "video/quicktime"
];
const MIME_TYPES_TO_EXTENSIONS = {
    ["application/pdf"]: [
        ".pdf"
    ],
    ["image/jpg"]: [
        ".jpg",
        ".jpeg"
    ],
    ["image/jpeg"]: [
        ".jpg",
        ".jpeg"
    ],
    ["image/png"]: [
        ".png"
    ],
    ["application/json"]: [
        ".json"
    ],
    ["application/geo+json"]: [
        ".geojson"
    ],
    ["application/geopackage+vnd.sqlite3"]: [
        ".gpkg"
    ],
    ["text/csv"]: [
        ".csv"
    ],
    ["video/mp4"]: [
        ".mp4"
    ],
    ["video/quicktime"]: [
        ".mov"
    ],
    ["application/zip"]: [
        ".zip"
    ]
};
var TRANSCRIPTION_TASK_PRIORITY = /*#__PURE__*/ function(TRANSCRIPTION_TASK_PRIORITY) {
    TRANSCRIPTION_TASK_PRIORITY["LOW"] = "low";
    TRANSCRIPTION_TASK_PRIORITY["MEDIUM"] = "medium";
    TRANSCRIPTION_TASK_PRIORITY["HIGH"] = "high";
    return TRANSCRIPTION_TASK_PRIORITY;
}({});
var MAP_COMPONENTS = /*#__PURE__*/ function(MAP_COMPONENTS) {
    MAP_COMPONENTS["PANELS"] = "panels";
    MAP_COMPONENTS["BASE_FLOOD_ELEVATIONS"] = "baseFloodElevations";
    MAP_COMPONENTS["CROSS_SECTIONS"] = "crossSections";
    MAP_COMPONENTS["PROFILE_BASELINES"] = "profileBaselines";
    return MAP_COMPONENTS;
}({});
const LIGHT_GRAY_BASE_MAP_URL = "mapbox://styles/sashako/ckv1c734s2mn014o6v0hxvibf";
const SATELLITE_BASE_MAP_URL = "mapbox://styles/sashako/ckv19e52n25no14leu6hyode6";
var POINT_MAP_ICON = /*#__PURE__*/ function(POINT_MAP_ICON) {
    POINT_MAP_ICON["CIRCLE"] = "circle";
    POINT_MAP_ICON["CIRCLE_DOT"] = "circle-dot";
    POINT_MAP_ICON["CIRCLE_ALERT"] = "circle-alert";
    POINT_MAP_ICON["SQUARE"] = "square";
    POINT_MAP_ICON["DIAMOND"] = "diamond";
    POINT_MAP_ICON["STAR"] = "star";
    POINT_MAP_ICON["SPARKLE"] = "sparkle";
    return POINT_MAP_ICON;
}({});
var POINT_MAP_ICON_GRAPHQL = /*#__PURE__*/ function(POINT_MAP_ICON_GRAPHQL) {
    POINT_MAP_ICON_GRAPHQL["CIRCLE"] = "circle";
    POINT_MAP_ICON_GRAPHQL["CIRCLE_DOT"] = "circle_dot";
    POINT_MAP_ICON_GRAPHQL["CIRCLE_ALERT"] = "circle_alert";
    POINT_MAP_ICON_GRAPHQL["SQUARE"] = "square";
    POINT_MAP_ICON_GRAPHQL["DIAMOND"] = "diamond";
    POINT_MAP_ICON_GRAPHQL["STAR"] = "star";
    POINT_MAP_ICON_GRAPHQL["SPARKLE"] = "sparkle";
    return POINT_MAP_ICON_GRAPHQL;
}({});
const POINT_MAP_ICON_TO_GRAPHQL = Object.fromEntries(Object.keys(POINT_MAP_ICON).map((key)=>[
        POINT_MAP_ICON[key],
        POINT_MAP_ICON_GRAPHQL[key]
    ]));
const GRAPHQL_TO_POINT_MAP_ICON = Object.fromEntries(Object.entries(POINT_MAP_ICON_TO_GRAPHQL).map(([k, v])=>[
        v,
        k
    ]));
const DEFAULT_MAP_STYLES = {
    fillColor: "hsla(0, 0, 0, 0)",
    fillOpacity: 0.5,
    lineColor: "#ffffff",
    lineOpacity: 1,
    lineWidth: 0,
    icon: "circle",
    iconSize: 0.5
};
var MAP_LAYER_PATTERNS = /*#__PURE__*/ function(MAP_LAYER_PATTERNS) {
    MAP_LAYER_PATTERNS["CIRCLE"] = "circle-pattern";
    MAP_LAYER_PATTERNS["CROSS_HATCH"] = "cross-hatch-pattern";
    MAP_LAYER_PATTERNS["CROSS"] = "cross-pattern";
    MAP_LAYER_PATTERNS["GRID"] = "grid-pattern";
    MAP_LAYER_PATTERNS["HORIZONTAL"] = "horizontal-pattern";
    MAP_LAYER_PATTERNS["STAR"] = "star-pattern";
    MAP_LAYER_PATTERNS["SQUARE"] = "square-pattern";
    MAP_LAYER_PATTERNS["TRIANGLE"] = "triangle-pattern";
    MAP_LAYER_PATTERNS["VERTICAL"] = "vertical-pattern";
    return MAP_LAYER_PATTERNS;
}({});
const MAX_AMOUNT_FOR_INDIVIDUAL_EMAIL_SEND = 4;
var PARCEL_IMPORT_TASK_TYPE = /*#__PURE__*/ function(PARCEL_IMPORT_TASK_TYPE) {
    PARCEL_IMPORT_TASK_TYPE["GPKG"] = "gpkg";
    PARCEL_IMPORT_TASK_TYPE["ARCGIS"] = "arcgis";
    return PARCEL_IMPORT_TASK_TYPE;
}({});
var JOB_STATUS = /*#__PURE__*/ function(JOB_STATUS) {
    JOB_STATUS["SUCCESS"] = "success";
    JOB_STATUS["FAILURE"] = "failure";
    JOB_STATUS["PROCESSING"] = "processing";
    JOB_STATUS["UNKNOWN"] = "unknown";
    return JOB_STATUS;
}({});
var EXTRACT_GPKG_FIELDS_STATUS = /*#__PURE__*/ function(EXTRACT_GPKG_FIELDS_STATUS) {
    EXTRACT_GPKG_FIELDS_STATUS["SUCCESS"] = "success";
    EXTRACT_GPKG_FIELDS_STATUS["FAILURE"] = "failure";
    EXTRACT_GPKG_FIELDS_STATUS["IN_PROGRESS"] = "in_progress";
    return EXTRACT_GPKG_FIELDS_STATUS;
}({});
var PROPERTY_WARNING_GROUP = /*#__PURE__*/ function(PROPERTY_WARNING_GROUP) {
    PROPERTY_WARNING_GROUP["COMPLIANCE_WARNING"] = "compliance";
    PROPERTY_WARNING_GROUP["FIRM_WARNING"] = "firm";
    PROPERTY_WARNING_GROUP["IMPROVEMENT_WARNING"] = "improvement";
    PROPERTY_WARNING_GROUP["PRELIMINARY_DAMAGE_ASSESSMENT"] = "preliminaryDamageAssessment";
    PROPERTY_WARNING_GROUP["REPETITIVE_LOSS"] = "repetitiveLoss";
    PROPERTY_WARNING_GROUP["CUSTOM_WARNING"] = "custom";
    return PROPERTY_WARNING_GROUP;
}({});
var PROPERTY_WARNING_CODE = /*#__PURE__*/ function(PROPERTY_WARNING_CODE) {
    PROPERTY_WARNING_CODE["WITHIN_SFHA_EFFECTIVE_NO_PRELIMINARY"] = "WITHIN_SFHA.EFFECTIVE_NO_PRELIMINARY";
    PROPERTY_WARNING_CODE["WITHIN_SFHA_MAPPED_IN"] = "WITHIN_SFHA.MAPPED_IN";
    PROPERTY_WARNING_CODE["WITHIN_SFHA_MAPPED_OUT"] = "WITHIN_SFHA.MAPPED_OUT";
    PROPERTY_WARNING_CODE["FLOOD_MAP_CHANGES_FLOOD_ZONE"] = "FLOOD_MAP_CHANGES.FLOOD_ZONE";
    PROPERTY_WARNING_CODE["FLOOD_MAP_CHANGES_BFE"] = "FLOOD_MAP_CHANGES.BFE";
    PROPERTY_WARNING_CODE["LFE_BELOW_BFE_NFIP"] = "LFE_BELOW_BFE.NFIP";
    PROPERTY_WARNING_CODE["LFE_BELOW_BFE_REGULATORY"] = "LFE_BELOW_BFE.REGULATORY";
    PROPERTY_WARNING_CODE["MACHINERY_BELOW_BFE_NFIP"] = "MACHINERY_BELOW_BFE.NFIP";
    PROPERTY_WARNING_CODE["MACHINERY_BELOW_BFE_REGULATORY"] = "MACHINERY_BELOW_BFE.REGULATORY";
    PROPERTY_WARNING_CODE["IMPROVEMENT_THRESHOLD_WARNINGS_CLOSE"] = "IMPROVEMENT_THRESHOLD_WARNINGS.CLOSE";
    PROPERTY_WARNING_CODE["IMPROVEMENT_THRESHOLD_WARNINGS_OVER"] = "IMPROVEMENT_THRESHOLD_WARNINGS.OVER";
    PROPERTY_WARNING_CODE["PRELIMINARY_DAMAGE_ASSESSMENT_NONE"] = "PRELIMINARY_DAMAGE_ASSESSMENT.NONE";
    PROPERTY_WARNING_CODE["PRELIMINARY_DAMAGE_ASSESSMENT_AFFECTED"] = "PRELIMINARY_DAMAGE_ASSESSMENT.AFFECTED";
    PROPERTY_WARNING_CODE["PRELIMINARY_DAMAGE_ASSESSMENT_MINOR"] = "PRELIMINARY_DAMAGE_ASSESSMENT.MINOR";
    PROPERTY_WARNING_CODE["PRELIMINARY_DAMAGE_ASSESSMENT_MAJOR"] = "PRELIMINARY_DAMAGE_ASSESSMENT.MAJOR";
    PROPERTY_WARNING_CODE["PRELIMINARY_DAMAGE_ASSESSMENT_DESTROYED"] = "PRELIMINARY_DAMAGE_ASSESSMENT.DESTROYED";
    PROPERTY_WARNING_CODE["PRELIMINARY_DAMAGE_ASSESSMENT_UNKNOWN"] = "PRELIMINARY_DAMAGE_ASSESSMENT.UNKNOWN";
    PROPERTY_WARNING_CODE["REPETITIVE_LOSS_IS_REPETITIVE_LOSS"] = "REPETITIVE_LOSS.IS_REPETITIVE_LOSS";
    PROPERTY_WARNING_CODE["REPETITIVE_LOSS_IS_SEVERE_REPETITIVE_LOSS"] = "REPETITIVE_LOSS.IS_SEVERE_REPETITIVE_LOSS";
    return PROPERTY_WARNING_CODE;
}({});
var PROPERTY_WARNING_SEVERITY = /*#__PURE__*/ function(PROPERTY_WARNING_SEVERITY) {
    PROPERTY_WARNING_SEVERITY["LOW"] = "low";
    PROPERTY_WARNING_SEVERITY["MEDIUM"] = "medium";
    PROPERTY_WARNING_SEVERITY["HIGH"] = "high";
    return PROPERTY_WARNING_SEVERITY;
}({});
var DAMAGE_DEGREE = /*#__PURE__*/ function(DAMAGE_DEGREE) {
    DAMAGE_DEGREE["AFFECTED"] = "affected";
    DAMAGE_DEGREE["MINOR"] = "minor";
    DAMAGE_DEGREE["MAJOR"] = "major";
    DAMAGE_DEGREE["DESTROYED"] = "destroyed";
    DAMAGE_DEGREE["UNKNOWN"] = "unknown";
    DAMAGE_DEGREE["NONE"] = "none";
    return DAMAGE_DEGREE;
}({});
var BOOLEAN_OPTIONS = /*#__PURE__*/ function(BOOLEAN_OPTIONS) {
    BOOLEAN_OPTIONS["YES"] = "yes";
    BOOLEAN_OPTIONS["NO"] = "no";
    BOOLEAN_OPTIONS["UNKNOWN"] = "unknown";
    return BOOLEAN_OPTIONS;
}({});
var BASE_MAP_SOURCE_TYPE = /*#__PURE__*/ function(BASE_MAP_SOURCE_TYPE) {
    BASE_MAP_SOURCE_TYPE["IMAGE_SERVER"] = "image_server";
    BASE_MAP_SOURCE_TYPE["MAP_SERVER"] = "map_server";
    BASE_MAP_SOURCE_TYPE["MAPBOX"] = "mapbox";
    BASE_MAP_SOURCE_TYPE["SLIPPY"] = "slippy";
    return BASE_MAP_SOURCE_TYPE;
}({});
var ADJACENT_GRADE_TYPE = /*#__PURE__*/ function(ADJACENT_GRADE_TYPE) {
    ADJACENT_GRADE_TYPE["NATURAL"] = "natural";
    ADJACENT_GRADE_TYPE["FINISHED"] = "finished";
    return ADJACENT_GRADE_TYPE;
}({});
var AWS_BATCH_JOB_TYPE = /*#__PURE__*/ function(AWS_BATCH_JOB_TYPE) {
    AWS_BATCH_JOB_TYPE["FIRM_IMPORT"] = "firm_import";
    AWS_BATCH_JOB_TYPE["REPETITIVE_LOSS_IMPORT"] = "repetitive_loss_import";
    AWS_BATCH_JOB_TYPE["PARCEL_IMPORT"] = "parcel_import";
    AWS_BATCH_JOB_TYPE["SCRIPT"] = "script";
    AWS_BATCH_JOB_TYPE["BUILD_OFFLINE_PACK"] = "build_offline_pack";
    AWS_BATCH_JOB_TYPE["AUTOMATION"] = "automation";
    return AWS_BATCH_JOB_TYPE;
}({});
var AWS_BATCH_JOB_STATUS = /*#__PURE__*/ function(AWS_BATCH_JOB_STATUS) {
    AWS_BATCH_JOB_STATUS["SUBMITTED"] = "SUBMITTED";
    AWS_BATCH_JOB_STATUS["PENDING"] = "PENDING";
    AWS_BATCH_JOB_STATUS["RUNNABLE"] = "RUNNABLE";
    AWS_BATCH_JOB_STATUS["STARTING"] = "STARTING";
    AWS_BATCH_JOB_STATUS["RUNNING"] = "RUNNING";
    AWS_BATCH_JOB_STATUS["SUCCEEDED"] = "SUCCEEDED";
    AWS_BATCH_JOB_STATUS["FAILED"] = "FAILED";
    AWS_BATCH_JOB_STATUS["UNKNOWN"] = "UNKNOWN";
    return AWS_BATCH_JOB_STATUS;
}({});
var FIRM_IMPORT_JOB_ERROR_TYPE = /*#__PURE__*/ function(FIRM_IMPORT_JOB_ERROR_TYPE) {
    FIRM_IMPORT_JOB_ERROR_TYPE["GENERAL"] = "GENERAL";
    FIRM_IMPORT_JOB_ERROR_TYPE["GEOJSON_VALIDATION_FAILURE"] = "GEOJSON_VALIDATION_FAILURE";
    return FIRM_IMPORT_JOB_ERROR_TYPE;
}({});
var CUSTOM_MAP_TYPE = /*#__PURE__*/ function(CUSTOM_MAP_TYPE) {
    CUSTOM_MAP_TYPE["INCLUSION_EXCLUSION"] = "inclusion_exclusion";
    CUSTOM_MAP_TYPE["MULTIPLE_INCLUSIONS"] = "multiple_inclusions";
    CUSTOM_MAP_TYPE["GREATEST_INCLUSION"] = "greatest_inclusion";
    CUSTOM_MAP_TYPE["VISUAL"] = "visual";
    return CUSTOM_MAP_TYPE;
}({});
var CERTIFICATE_UPLOAD_CANCELATION_REASON = /*#__PURE__*/ function(CERTIFICATE_UPLOAD_CANCELATION_REASON) {
    CERTIFICATE_UPLOAD_CANCELATION_REASON["QUALITY"] = "QUALITY";
    CERTIFICATE_UPLOAD_CANCELATION_REASON["CANNOT_GEOCODE"] = "CANNOT_GEOCODE";
    CERTIFICATE_UPLOAD_CANCELATION_REASON["NOT_EC"] = "NOT_EC";
    return CERTIFICATE_UPLOAD_CANCELATION_REASON;
}({});
var SUBMISSION_STATUS = /*#__PURE__*/ function(SUBMISSION_STATUS) {
    SUBMISSION_STATUS["CANCELED"] = "canceled";
    SUBMISSION_STATUS["PROCESSING"] = "processing";
    SUBMISSION_STATUS["COMPLETED"] = "completed";
    return SUBMISSION_STATUS;
}({});
var DFE_DETERMINATION_METHOD = /*#__PURE__*/ function(DFE_DETERMINATION_METHOD) {
    DFE_DETERMINATION_METHOD["DISABLED"] = "disabled";
    DFE_DETERMINATION_METHOD["MANUAL"] = "manual";
    DFE_DETERMINATION_METHOD["AUTOMATIC"] = "automatic";
    return DFE_DETERMINATION_METHOD;
}({});
var INFORMATION_REQUEST_STATUS = /*#__PURE__*/ function(INFORMATION_REQUEST_STATUS) {
    INFORMATION_REQUEST_STATUS["OPEN"] = "open";
    INFORMATION_REQUEST_STATUS["IN_PROGRESS"] = "in_progress";
    INFORMATION_REQUEST_STATUS["COMPLETE"] = "complete";
    return INFORMATION_REQUEST_STATUS;
}({});
const SUPPORT_EMAIL = "support@withforerunner.com";
var SEARCH_CATEGORY = /*#__PURE__*/ function(SEARCH_CATEGORY) {
    SEARCH_CATEGORY["ADDRESS"] = "address";
    SEARCH_CATEGORY["PARCEL_ID"] = "parcelId";
    SEARCH_CATEGORY["BLOCK_LOT"] = "blockLot";
    return SEARCH_CATEGORY;
}({});
var REPETITIVE_LOSS_IMPORT_ISSUE = /*#__PURE__*/ function(REPETITIVE_LOSS_IMPORT_ISSUE) {
    REPETITIVE_LOSS_IMPORT_ISSUE["FAILED"] = "failed";
    REPETITIVE_LOSS_IMPORT_ISSUE["MISSING_PROPERTY"] = "missing_property";
    REPETITIVE_LOSS_IMPORT_ISSUE["MISSING_PARCEL"] = "missing_parcel";
    REPETITIVE_LOSS_IMPORT_ISSUE["PARCEL_QUALITY"] = "parcel_quality";
    return REPETITIVE_LOSS_IMPORT_ISSUE;
}({});
const RepetitiveLossIssueList = [
    "missing_property",
    "missing_parcel",
    "parcel_quality"
];
var HELP_OPTION_REASON_CODE = /*#__PURE__*/ function(HELP_OPTION_REASON_CODE) {
    HELP_OPTION_REASON_CODE["REQUEST_BFE"] = "requestBFE";
    return HELP_OPTION_REASON_CODE;
}({});
var SUBMISSION_CATEGORY = /*#__PURE__*/ function(SUBMISSION_CATEGORY) {
    SUBMISSION_CATEGORY["INSPECTIONS"] = "inspections";
    SUBMISSION_CATEGORY["PERMITTING"] = "permitting";
    SUBMISSION_CATEGORY["SUBSTANTIAL_IMPROVEMENT_SUBSTANTIAL_DAMAGE"] = "substantial_improvement_substantial_damage";
    SUBMISSION_CATEGORY["GRANTS"] = "grants";
    SUBMISSION_CATEGORY["PAYMENTS"] = "payments";
    SUBMISSION_CATEGORY["MAILINGS"] = "mailings";
    SUBMISSION_CATEGORY["CODE_CASES"] = "code_cases";
    SUBMISSION_CATEGORY["PROJECTS"] = "projects";
    SUBMISSION_CATEGORY["PLANNING"] = "planning";
    SUBMISSION_CATEGORY["INSURANCE"] = "insurance";
    SUBMISSION_CATEGORY["COMPLAINTS"] = "complaints";
    SUBMISSION_CATEGORY["ASSESSMENTS"] = "assessments";
    SUBMISSION_CATEGORY["ZONING_REVIEWS"] = "zoning_reviews";
    SUBMISSION_CATEGORY["TICKETS"] = "tickets";
    SUBMISSION_CATEGORY["TAXES"] = "taxes";
    SUBMISSION_CATEGORY["RECORDS"] = "records";
    SUBMISSION_CATEGORY["WORK_ORDERS"] = "work_orders";
    SUBMISSION_CATEGORY["FIRE_PREVENTION"] = "fire_prevention";
    return SUBMISSION_CATEGORY;
}({});
var USER_LOGIN_ERROR_CODE = /*#__PURE__*/ function(USER_LOGIN_ERROR_CODE) {
    USER_LOGIN_ERROR_CODE["UNEXPECTED_ERROR"] = "unexpected_error";
    USER_LOGIN_ERROR_CODE["MISSING_EMAIL_OR_PASSWORD"] = "missing_email_or_password";
    USER_LOGIN_ERROR_CODE["INCORRECT_USERNAME_OR_PASSWORD"] = "incorrect_username_or_password";
    USER_LOGIN_ERROR_CODE["MAX_LOGIN_ATTEMPTS_EXCEEDED"] = "max_login_attempts_exceeded";
    USER_LOGIN_ERROR_CODE["PASSWORD_EXPIRED"] = "password_expired";
    USER_LOGIN_ERROR_CODE["INVALID_CODE"] = "invalid_code";
    USER_LOGIN_ERROR_CODE["EXPIRED_CODE"] = "expired_code";
    USER_LOGIN_ERROR_CODE["INVALID_PHONE_NUMBER"] = "invalid_phone_number";
    USER_LOGIN_ERROR_CODE["PHONE_NUMBER_ALREADY_IN_USE"] = "phone_number_already_in_use";
    USER_LOGIN_ERROR_CODE["RESEND_CODE_TOO_SOON"] = "resend_code_too_soon";
    USER_LOGIN_ERROR_CODE["MOBILE_APP_DISABLED"] = "mobile_app_disabled";
    USER_LOGIN_ERROR_CODE["PASSWORD_RESET_REQUIRED"] = "password_reset_required";
    USER_LOGIN_ERROR_CODE["MULTIPLE_ACCOUNTS_ASSOCIATED_WITH_EMAIL"] = "multiple_accounts_associated_with_email";
    USER_LOGIN_ERROR_CODE["MISSING_TOTP_SETUP"] = "missing_totp_setup";
    USER_LOGIN_ERROR_CODE["INVALID_TOTP_SETUP"] = "invalid_totp_setup";
    return USER_LOGIN_ERROR_CODE;
}({});
var SSO_ERROR_CODE = /*#__PURE__*/ function(SSO_ERROR_CODE) {
    SSO_ERROR_CODE["INVALID_STATE"] = "sso_invalid_state";
    SSO_ERROR_CODE["PROVIDER_NOT_FOUND"] = "sso_provider_not_found";
    SSO_ERROR_CODE["PROVIDER_NOT_ENABLED"] = "sso_provider_not_enabled";
    SSO_ERROR_CODE["USER_NOT_FOUND"] = "sso_user_not_found";
    SSO_ERROR_CODE["USER_SUSPENDED"] = "sso_user_suspended";
    SSO_ERROR_CODE["INVALID_TOKEN"] = "sso_invalid_token";
    SSO_ERROR_CODE["INVALID_REQUEST"] = "sso_invalid_request";
    SSO_ERROR_CODE["INITIALIZATION_FAILED"] = "sso_initialization_failed";
    SSO_ERROR_CODE["SESSION_CREATION_FAILED"] = "sso_session_creation_failed";
    SSO_ERROR_CODE["AUTHENTICATION_FAILED"] = "sso_authentication_failed";
    SSO_ERROR_CODE["SSO_FAILED"] = "sso_failed";
    return SSO_ERROR_CODE;
}({});
const isSsoErrorCode = (value)=>{
    return Object.values(SSO_ERROR_CODE).includes(value);
};
var PUBLIC_USER_SIGNUP_ERROR_CODE = /*#__PURE__*/ function(PUBLIC_USER_SIGNUP_ERROR_CODE) {
    PUBLIC_USER_SIGNUP_ERROR_CODE["EMAIL_INVALID"] = "email_invalid";
    PUBLIC_USER_SIGNUP_ERROR_CODE["EMAIL_REQUIRED"] = "email_required";
    PUBLIC_USER_SIGNUP_ERROR_CODE["PASSWORD_INVALID"] = "password_invalid";
    PUBLIC_USER_SIGNUP_ERROR_CODE["PASSWORD_REQUIRED"] = "password_required";
    PUBLIC_USER_SIGNUP_ERROR_CODE["SIGNUP_ERROR"] = "signup_error";
    return PUBLIC_USER_SIGNUP_ERROR_CODE;
}({});
var CONFIRM_EMAIL_ERROR_CODE = /*#__PURE__*/ function(CONFIRM_EMAIL_ERROR_CODE) {
    CONFIRM_EMAIL_ERROR_CODE["CONFIRMATION_CODE_INVALID"] = "confirmation_code_invalid";
    CONFIRM_EMAIL_ERROR_CODE["CONFIRMATION_CODE_EXPIRED"] = "confirmation_code_expired";
    CONFIRM_EMAIL_ERROR_CODE["ERROR"] = "error";
    return CONFIRM_EMAIL_ERROR_CODE;
}({});
var ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE = /*#__PURE__*/ function(ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE) {
    ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE["INVITE_NOT_FOUND"] = "invite_not_found";
    ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE["INVITE_ALREADY_ACCEPTED"] = "invite_already_accepted";
    return ACCEPT_PUBLIC_USER_INVITE_ERROR_CODE;
}({});
var RESET_PASSWORD_ERROR_CODE = /*#__PURE__*/ function(RESET_PASSWORD_ERROR_CODE) {
    RESET_PASSWORD_ERROR_CODE["NO_PASSWORD_RESET_REQUEST_FOUND"] = "no_password_reset_request_found";
    RESET_PASSWORD_ERROR_CODE["INCORRECT_PASSWORD"] = "incorrect_password";
    RESET_PASSWORD_ERROR_CODE["PASSWORD_MISSING_REQUIREMENTS"] = "password_missing_requirements";
    RESET_PASSWORD_ERROR_CODE["PASSWORD_REQUIRED"] = "password_required";
    RESET_PASSWORD_ERROR_CODE["NEW_PASSWORD_SAME_AS_OLD_PASSWORD"] = "new_password_same_as_old_password";
    RESET_PASSWORD_ERROR_CODE["PASSWORD_RESET_REQUEST_UNEXPECTED_ERROR"] = "password_reset_request_unexpected_error";
    RESET_PASSWORD_ERROR_CODE["SSO_USER"] = "sso_user";
    return RESET_PASSWORD_ERROR_CODE;
}({});
var VALIDATION_STATUS = /*#__PURE__*/ function(VALIDATION_STATUS) {
    VALIDATION_STATUS["PENDING"] = "pending";
    VALIDATION_STATUS["APPROVED"] = "approved";
    VALIDATION_STATUS["CANCELED"] = "canceled";
    // When the code is expired, twilio just deletes reference to it and throws an error on verify
    // We are adding expired so we can have an informative UI
    VALIDATION_STATUS["EXPIRED"] = "expired";
    return VALIDATION_STATUS;
}({});
var RASTER_SOURCE_TYPE = /*#__PURE__*/ function(RASTER_SOURCE_TYPE) {
    RASTER_SOURCE_TYPE["IMAGE_SERVER"] = "image_server";
    RASTER_SOURCE_TYPE["S3"] = "s3";
    return RASTER_SOURCE_TYPE;
}({});
var RASTER_LAYER_SECTION = /*#__PURE__*/ function(RASTER_LAYER_SECTION) {
    RASTER_LAYER_SECTION["FLOOD"] = "flood";
    RASTER_LAYER_SECTION["LAND"] = "land";
    RASTER_LAYER_SECTION["CUSTOM"] = "custom";
    return RASTER_LAYER_SECTION;
}({});
var BUILDING_LOCATED_IN_CBRS_OR_OPA = /*#__PURE__*/ function(BUILDING_LOCATED_IN_CBRS_OR_OPA) {
    BUILDING_LOCATED_IN_CBRS_OR_OPA["CBRS"] = "cbrs";
    BUILDING_LOCATED_IN_CBRS_OR_OPA["OPA"] = "opa";
    return BUILDING_LOCATED_IN_CBRS_OR_OPA;
}({});
var UNIT_OF_MEASUREMENT = /*#__PURE__*/ function(UNIT_OF_MEASUREMENT) {
    UNIT_OF_MEASUREMENT["FEET"] = "feet";
    UNIT_OF_MEASUREMENT["METERS"] = "meters";
    return UNIT_OF_MEASUREMENT;
}({});
var SYSTEM_OF_MEASUREMENT = /*#__PURE__*/ function(SYSTEM_OF_MEASUREMENT) {
    SYSTEM_OF_MEASUREMENT["US_CUSTOMARY"] = "us_customary";
    SYSTEM_OF_MEASUREMENT["METRIC"] = "metric";
    return SYSTEM_OF_MEASUREMENT;
}({});
const FEET_PER_METER = 3.28084;
const FEET_PER_MILE = 5280;
const METERS_PER_MILE = 1609.344;
var DFE_UNIT_OF_MEASUREMENT = /*#__PURE__*/ function(DFE_UNIT_OF_MEASUREMENT) {
    DFE_UNIT_OF_MEASUREMENT["FEET"] = "feet";
    DFE_UNIT_OF_MEASUREMENT["INCHES"] = "inches";
    return DFE_UNIT_OF_MEASUREMENT;
}({});
var RASTER_UNIT_OF_MEASUREMENT = /*#__PURE__*/ function(RASTER_UNIT_OF_MEASUREMENT) {
    RASTER_UNIT_OF_MEASUREMENT["FEET"] = "feet";
    RASTER_UNIT_OF_MEASUREMENT["INCHES"] = "inches";
    RASTER_UNIT_OF_MEASUREMENT["METERS"] = "meters";
    return RASTER_UNIT_OF_MEASUREMENT;
}({});
var PERMIT_ISSUE_TYPE = /*#__PURE__*/ function(PERMIT_ISSUE_TYPE) {
    PERMIT_ISSUE_TYPE["NEW_CONSTRUCTION"] = "new_construction";
    PERMIT_ISSUE_TYPE["SUBSTANTIAL_IMPROVEMENT"] = "substantial_improvement";
    return PERMIT_ISSUE_TYPE;
}({});
var ABOVE_OR_BELOW = /*#__PURE__*/ function(ABOVE_OR_BELOW) {
    ABOVE_OR_BELOW["ABOVE"] = "above";
    ABOVE_OR_BELOW["BELOW"] = "below";
    return ABOVE_OR_BELOW;
}({});
const FLAGGED_REASONS = [
    "Unable to geolocate this parcel with certainty",
    "Unable to determine which building the EC pertains to on the parcel",
    "Coordinates are outside the account boundary",
    "Unable to geocode due to incomplete address",
    "Multiple responses in a field that only allows one response",
    "Missing pages or sections",
    "Multiple addresses on the EC",
    "Multiple ECs in the file",
    "Expiration Year missing/illegible",
    "EC is illegible",
    "Not an EC",
    "Failed to standardize address",
    "Other"
];
var CBRS_TYPE = /*#__PURE__*/ function(CBRS_TYPE) {
    CBRS_TYPE["SYSTEM_UNIT"] = "System Unit";
    CBRS_TYPE["OTHERWISE_PROTECTED_AREA"] = "Otherwise Protected Area";
    return CBRS_TYPE;
}({});
const CBRS_TYPE_SORT_ORDER = [
    "Otherwise Protected Area",
    "System Unit"
];
var PDF_MAPPING_TYPE = /*#__PURE__*/ function(PDF_MAPPING_TYPE) {
    PDF_MAPPING_TYPE["BOOLEAN"] = "boolean";
    PDF_MAPPING_TYPE["STRING"] = "string";
    PDF_MAPPING_TYPE["IMAGE"] = "image";
    PDF_MAPPING_TYPE["ANY"] = "any";
    return PDF_MAPPING_TYPE;
}({});
const MAPPING_TYPE_MISMATCH_ERROR = `Selected field type is not compatible with the PDF field type.`;
const GENERIC_FORERUNNER_KEYS = [
    "todaysDate",
    "account.name",
    "account.communityNumber",
    "account.communityName"
];
const LOAD_ALL_DATA_DYNAMIC_TOP_LEVEL_KEYS = [
    "firms",
    "parcel",
    "submissions"
];
const PROPERTY_FORERUNNER_KEYS = [
    "firm.freeboard",
    "property.streetAddress",
    "property.addressLine2",
    "property.cumulativeImprovementProgress",
    "property.improvementTotal",
    "property.fullAssessedValue"
];
const FIRM_FORERUNNER_KEYS = [
    "effectiveDate",
    "panelNumber",
    "stringStaticBFE",
    "dfeValue",
    "floodzone",
    "datum",
    "sfhaDetermination",
    "outSFHACheckbox",
    "inSFHACheckbox",
    "screenshot"
];
const genericDocGenOptions = [
    {
        label: "Today's Date",
        value: "todaysDate",
        type: "string"
    },
    {
        label: "Account Name",
        value: "account.name",
        type: "string"
    },
    {
        label: "Community Number",
        value: "account.communityNumber",
        type: "string"
    },
    {
        label: "Community Name",
        value: "account.communityName",
        type: "string"
    }
];
const propertyDocGenOptions = [
    {
        label: "Property Address line 1",
        value: "property.streetAddress",
        type: "string"
    },
    {
        label: "Property Address line 2",
        value: "property.addressLine2",
        type: "string"
    },
    {
        label: "SISD Percentage",
        value: "property.cumulativeImprovementProgress",
        type: "string"
    },
    {
        label: "SISD Value",
        value: "property.improvementTotal",
        type: "string"
    },
    {
        label: "Full Assessed Value",
        value: "property.fullAssessedValue",
        type: "string"
    }
];
const firmDocGenOptions = [
    {
        label: "Panel Effective Date",
        value: "effectiveDate",
        type: "string"
    },
    {
        label: "Panel Number",
        value: "panelNumber",
        type: "string"
    },
    {
        label: "Base Flood Elevation",
        value: "stringStaticBFE",
        type: "string"
    },
    {
        label: "Design Flood Elevation",
        value: "dfeValue",
        type: "string"
    },
    {
        label: "Floodzone",
        value: "floodzone",
        type: "string"
    },
    {
        label: "Datum",
        value: "datum",
        type: "string"
    },
    {
        label: "SFHA Determination",
        value: "sfhaDetermination",
        type: "string"
    },
    {
        label: "In SFHA checkbox",
        value: "inSFHACheckbox",
        type: "boolean"
    },
    {
        label: "Out SFHA checkbox",
        value: "outSFHACheckbox",
        type: "boolean"
    },
    {
        label: "screenshot",
        value: "screenshot",
        type: "image"
    }
];
var MOBILE_PLATFORM = /*#__PURE__*/ function(MOBILE_PLATFORM) {
    MOBILE_PLATFORM["IOS"] = "ios";
    MOBILE_PLATFORM["ANDROID"] = "android";
    return MOBILE_PLATFORM;
}({});
var DATUM_CONVERSION_OFFSET_PURPOSE = /*#__PURE__*/ function(DATUM_CONVERSION_OFFSET_PURPOSE) {
    DATUM_CONVERSION_OFFSET_PURPOSE["FALLBACK"] = "fallback";
    DATUM_CONVERSION_OFFSET_PURPOSE["OVERRIDE"] = "override";
    return DATUM_CONVERSION_OFFSET_PURPOSE;
}({});
var OFFLINE_PACK_STATUS = /*#__PURE__*/ function(OFFLINE_PACK_STATUS) {
    OFFLINE_PACK_STATUS["PROCESSING"] = "processing";
    OFFLINE_PACK_STATUS["COMPLETE"] = "complete";
    OFFLINE_PACK_STATUS["ERROR"] = "error";
    return OFFLINE_PACK_STATUS;
}({});
var RULE_DEFINITION_TYPE = /*#__PURE__*/ function(RULE_DEFINITION_TYPE) {
    RULE_DEFINITION_TYPE["DFE"] = "dfe";
    RULE_DEFINITION_TYPE["SISD"] = "sisd";
    return RULE_DEFINITION_TYPE;
}({});
var RULE_MAP_FILTER_TYPE = /*#__PURE__*/ function(RULE_MAP_FILTER_TYPE) {
    RULE_MAP_FILTER_TYPE["REGULATORY_FIRM"] = "regulatoryFirm";
    return RULE_MAP_FILTER_TYPE;
}({});
var DFE_RULE_TYPE = /*#__PURE__*/ function(DFE_RULE_TYPE) {
    DFE_RULE_TYPE["AUTOMATIC"] = "automatic";
    DFE_RULE_TYPE["MINIMUM"] = "minimum";
    DFE_RULE_TYPE["MANUAL"] = "manual";
    return DFE_RULE_TYPE;
}({});
var PROPERTY_ATTRIBUTE_SOURCE = /*#__PURE__*/ function(PROPERTY_ATTRIBUTE_SOURCE) {
    PROPERTY_ATTRIBUTE_SOURCE["FEMA"] = "fema";
    PROPERTY_ATTRIBUTE_SOURCE["CUSTOM_MAP"] = "custom_map";
    PROPERTY_ATTRIBUTE_SOURCE["RASTER"] = "raster";
    return PROPERTY_ATTRIBUTE_SOURCE;
}({});
const PROPERTY_ATTRIBUTE_SOURCE_LABEL_MAP = {
    ["custom_map"]: "Custom map",
    ["fema"]: "FEMA NFHL",
    ["raster"]: "Raster"
};
var PROPERTY_ATTRIBUTE_NAMES = /*#__PURE__*/ function(PROPERTY_ATTRIBUTE_NAMES) {
    PROPERTY_ATTRIBUTE_NAMES["FLOODZONE"] = "floodzone";
    PROPERTY_ATTRIBUTE_NAMES["COASTAL_A"] = "coastalA";
    PROPERTY_ATTRIBUTE_NAMES["FLOODWAY"] = "floodway";
    PROPERTY_ATTRIBUTE_NAMES["CBRS"] = "cbrs";
    PROPERTY_ATTRIBUTE_NAMES["OPA"] = "opa";
    PROPERTY_ATTRIBUTE_NAMES["BFE"] = "bfe";
    PROPERTY_ATTRIBUTE_NAMES["DEPTH"] = "depth";
    PROPERTY_ATTRIBUTE_NAMES["DFE"] = "dfe";
    PROPERTY_ATTRIBUTE_NAMES["DATUM"] = "datum";
    PROPERTY_ATTRIBUTE_NAMES["EFFECTIVE_DATE"] = "effectiveDate";
    PROPERTY_ATTRIBUTE_NAMES["PANEL_NUMBER"] = "panelNumber";
    PROPERTY_ATTRIBUTE_NAMES["MSC_LINK"] = "mscLink";
    PROPERTY_ATTRIBUTE_NAMES["INITIAL_DATE"] = "initialDate";
    PROPERTY_ATTRIBUTE_NAMES["PRE_POST_FIRM"] = "prePostFIRM";
    PROPERTY_ATTRIBUTE_NAMES["BUILDING_DIAGRAM"] = "buildingDiagram";
    PROPERTY_ATTRIBUTE_NAMES["TOP_OF_BOTTOM_FLOOR"] = "topOfBottomFloor";
    PROPERTY_ATTRIBUTE_NAMES["TOP_OF_NEXT_HIGHER_FLOOR"] = "topOfNextHigherFloor";
    PROPERTY_ATTRIBUTE_NAMES["BOTTOM_OF_THE_LOWEST_HORIZONTAL_STRUCTURAL_MEMBER"] = "bottomOfTheLowestHorizontalStructuralMember";
    PROPERTY_ATTRIBUTE_NAMES["ATTACHED_GARAGE"] = "attachedGarage";
    PROPERTY_ATTRIBUTE_NAMES["LOWEST_ELEVATION_OF_MACHINERY"] = "lowestElevationOfMachinery";
    PROPERTY_ATTRIBUTE_NAMES["LOWEST_ADJACENT_GRADE"] = "lowestAdjacentGrade";
    PROPERTY_ATTRIBUTE_NAMES["HIGHEST_ADJACENT_GRADE"] = "highestAdjacentGrade";
    PROPERTY_ATTRIBUTE_NAMES["LOWEST_ADJACENT_GRADE_AT_DECK_OR_STAIRS"] = "lowestAdjacentGradeAtDeckOrStairs";
    PROPERTY_ATTRIBUTE_NAMES["LOWEST_FLOOR_ELEVATION"] = "lowestFloorElevation";
    PROPERTY_ATTRIBUTE_NAMES["CERTIFICATE_TYPE"] = "certificateType";
    return PROPERTY_ATTRIBUTE_NAMES;
}({});
const ACCOUNT_DFE_RULE_NAME = "Account DFE Rule";
const ACCOUNT_SISD_RULE_NAME = "Account SI/SD Rule";
var ACCOUNT_WEBHOOK_TYPE = /*#__PURE__*/ function(ACCOUNT_WEBHOOK_TYPE) {
    ACCOUNT_WEBHOOK_TYPE["DOCUMENT_PROCESSED"] = "document_processed";
    return ACCOUNT_WEBHOOK_TYPE;
}({});
const SAME_RULE_NAME_ERROR = "This logic rule name already exists. Please choose another name and try again.";
const PROPERTY_ATTRIBUTE_NAME_ALREADY_EXISTS_ERROR = "This attribute name already exists.";
var OFFLINE_PACK_FILES = /*#__PURE__*/ function(OFFLINE_PACK_FILES) {
    OFFLINE_PACK_FILES["FIRM_PANELS"] = "firmPanels";
    OFFLINE_PACK_FILES["CROSS_SECTIONS"] = "crossSections";
    OFFLINE_PACK_FILES["PARCELS"] = "parcels";
    OFFLINE_PACK_FILES["PROFILE_BASELINES"] = "profileBaselines";
    OFFLINE_PACK_FILES["BASE_FLOOD_ELEVATIONS"] = "baseFloodElevations";
    OFFLINE_PACK_FILES["CUSTOM_MAPS"] = "customMaps";
    OFFLINE_PACK_FILES["LIMWAS"] = "limwas";
    OFFLINE_PACK_FILES["FLOOD_HAZARD_ZONES"] = "floodHazardZones";
    OFFLINE_PACK_FILES["CBRS"] = "cbrs";
    OFFLINE_PACK_FILES["COASTAL_A_ZONES"] = "coastalAZones";
    OFFLINE_PACK_FILES["PROPERTIES"] = "properties";
    OFFLINE_PACK_FILES["METADATA"] = "metadata";
    OFFLINE_PACK_FILES["TASKS"] = "tasks";
    OFFLINE_PACK_FILES["USERS"] = "users";
    return OFFLINE_PACK_FILES;
}({});
const WEB_REQUIRED_PASSWORD_RESET_MESSAGE = "Password requirements for your account have changed, please reset your password";
const US_EAST_2 = "us-east-2";
var COMMON_BASE_MAP_STYLES = /*#__PURE__*/ function(COMMON_BASE_MAP_STYLES) {
    COMMON_BASE_MAP_STYLES["SATELLITE_V2"] = "mapbox://styles/sashako/ckv19e52n25no14leu6hyode6";
    COMMON_BASE_MAP_STYLES["SATELLITE_COLORIZED"] = "mapbox://styles/sashako/clrlkqei3001i01q2ei3o3399";
    return COMMON_BASE_MAP_STYLES;
}({});
const SATELLITE_BASE_MAP = {
    id: SATELLITE_BASE_MAP_URL,
    name: "Satellite",
    isDefault: true,
    sourceType: "mapbox",
    mapboxStyleURL: SATELLITE_BASE_MAP_URL,
    sourceConfiguration: {}
};
const LIGHT_GRAY_BASE_MAP = {
    id: LIGHT_GRAY_BASE_MAP_URL,
    name: "Light Gray",
    isDefault: false,
    sourceType: "mapbox",
    mapboxStyleURL: LIGHT_GRAY_BASE_MAP_URL,
    sourceConfiguration: {}
};
const DEFAULT_PARCEL_IMPORT_FIELD_LABELS = {
    source_id: "Source ID",
    address: "Address",
    scity: "City",
    szip: "Zip",
    parcelId: "Parcel ID",
    state2: "State",
    landValue: "Land value",
    parcelValue: "Parcel value",
    improvementValue: "Improvement value",
    block: "Block",
    lot: "Lot",
    buildingDescription: "Property building description",
    yearBuilt: "Structure year built",
    owner: "Owner name",
    legalDescription: "Legal description",
    mailingAddress1: "Mailing address 1",
    mailingAddress2: "Mailing address 2",
    hiddenFromPublic: "Hidden from public"
};
var FEATURE_FLAG_NAME = /*#__PURE__*/ function(FEATURE_FLAG_NAME) {
    FEATURE_FLAG_NAME["PROPERTY_TABLE"] = "property_table";
    FEATURE_FLAG_NAME["MOBILE_OFFLINE_MODE_ACCESS"] = "mobile_offline_mode_access";
    FEATURE_FLAG_NAME["PUBLIC_USERS"] = "public_users";
    FEATURE_FLAG_NAME["PUBLIC_CUSTOM_OBJECTS"] = "public_custom_objects";
    FEATURE_FLAG_NAME["TASKS"] = "tasks";
    FEATURE_FLAG_NAME["TASKS_WEB"] = "tasks_web";
    FEATURE_FLAG_NAME["GEOCODING_UI"] = "geocoding_ui";
    FEATURE_FLAG_NAME["LOGS"] = "logs";
    FEATURE_FLAG_NAME["SEND_PHYSICAL_MAILINGS"] = "send_physical_mailings";
    FEATURE_FLAG_NAME["TABLE_ROW_SELECTION"] = "table_row_selection";
    FEATURE_FLAG_NAME["MERCHANDISING"] = "merchandising";
    FEATURE_FLAG_NAME["MEASURE_TOOL_WEB"] = "measure_tool_web";
    FEATURE_FLAG_NAME["LLM_CONDITIONAL_RULES_GENERATION"] = "llm_conditional_rules_generation";
    FEATURE_FLAG_NAME["SUBMISSIONS_CHAT_AGENT"] = "submissions_chat_agent";
    FEATURE_FLAG_NAME["SUBMISSION_BUILDER_USER_ACCESS"] = "submission_builder_user_access";
    FEATURE_FLAG_NAME["SUBMISSIONS_CHAT_AGENT_MOBILE"] = "submissions_chat_agent_mobile";
    return FEATURE_FLAG_NAME;
}({});
const RASTER_UNITS_SIGNIFIER = {
    ["feet"]: `\u2032`,
    ["inches"]: `\u2032\u2032`,
    ["meters"]: "m"
};
var MULTIPART_UPLOAD_TYPE = /*#__PURE__*/ function(MULTIPART_UPLOAD_TYPE) {
    MULTIPART_UPLOAD_TYPE["SCRIPT_JOB"] = "script_job";
    MULTIPART_UPLOAD_TYPE["DOCUMENT_UPLOADS"] = "document_uploads";
    MULTIPART_UPLOAD_TYPE["MOBILE_BACKUP_DATA"] = "mobile_backup_data";
    MULTIPART_UPLOAD_TYPE["BULK_PARCEL_UPLOAD"] = "bulk_parcel_upload";
    MULTIPART_UPLOAD_TYPE["ACCOUNT_LOGO_UPLOAD"] = "account_logo_upload";
    return MULTIPART_UPLOAD_TYPE;
}({});
var IMPROVEMENT_EXCLUSION_REASON = /*#__PURE__*/ function(IMPROVEMENT_EXCLUSION_REASON) {
    IMPROVEMENT_EXCLUSION_REASON["MANUAL"] = "manual";
    IMPROVEMENT_EXCLUSION_REASON["AUTOMATIC"] = "automatic";
    return IMPROVEMENT_EXCLUSION_REASON;
}({});
const MAX_POSTGRES_COLUMN_NAME_LENGTH = 63;
var EC_EXPORT_FORMAT = /*#__PURE__*/ function(EC_EXPORT_FORMAT) {
    EC_EXPORT_FORMAT["ZIP"] = "ZIP";
    EC_EXPORT_FORMAT["SHAPEFILE"] = "SHAPEFILE";
    EC_EXPORT_FORMAT["CSV"] = "CSV";
    EC_EXPORT_FORMAT["PERMIT_CSV"] = "PERMIT_CSV";
    EC_EXPORT_FORMAT["SDE_DATABASE"] = "SDE_DATABASE";
    return EC_EXPORT_FORMAT;
}({});
var QUERY_DESCRIPTION_EXPORT_FORMAT = /*#__PURE__*/ function(QUERY_DESCRIPTION_EXPORT_FORMAT) {
    QUERY_DESCRIPTION_EXPORT_FORMAT["GPKG"] = "GPKG";
    QUERY_DESCRIPTION_EXPORT_FORMAT["GDB"] = "GDB";
    QUERY_DESCRIPTION_EXPORT_FORMAT["CSV"] = "CSV";
    QUERY_DESCRIPTION_EXPORT_FORMAT["ZIP"] = "ZIP";
    return QUERY_DESCRIPTION_EXPORT_FORMAT;
}({});
var SAVED_VIEW_EXPORT_DESTINATION = /*#__PURE__*/ function(SAVED_VIEW_EXPORT_DESTINATION) {
    SAVED_VIEW_EXPORT_DESTINATION["S3"] = "S3";
    SAVED_VIEW_EXPORT_DESTINATION["ARCGIS"] = "ARCGIS";
    return SAVED_VIEW_EXPORT_DESTINATION;
}({});
var PRESAVED_QUERY_NAMES = /*#__PURE__*/ function(PRESAVED_QUERY_NAMES) {
    PRESAVED_QUERY_NAMES["PROPERTY_INSPECTIONS"] = "Property Inspections";
    PRESAVED_QUERY_NAMES["PDA"] = "Preliminaty Damage Assessments";
    return PRESAVED_QUERY_NAMES;
}({});
var TABLE_SUBSET_TYPE = /*#__PURE__*/ function(TABLE_SUBSET_TYPE) {
    TABLE_SUBSET_TYPE["CUSTOM_OBJECT_GROUP"] = "customObjectGroup";
    TABLE_SUBSET_TYPE["SUBMISSION_CATEGORY"] = "submissionCategory";
    TABLE_SUBSET_TYPE["WORKFLOW_DEFINITION"] = "workflowDefinition";
    return TABLE_SUBSET_TYPE;
}({});
const DEFAULT_SAVED_VIEW_TILE_LAYER = "src";
const SANITIZED_SAVED_VIEW_FORMATS = {
    ["GPKG"]: "geopackage (.gpkg)",
    ["CSV"]: "spreadsheet (.csv)",
    ["ZIP"]: "zip (.zip)",
    ["GDB"]: "geodatabase (.gdb)"
};
const EXTENSION_FOR_QUERY_DESCRIPTION_EXPORT_FORMAT = {
    ["GPKG"]: "gpkg",
    ["GDB"]: "gdb",
    ["CSV"]: "csv",
    ["ZIP"]: "zip"
};
var SUBMISSION_EXPORT_FORMAT = /*#__PURE__*/ function(SUBMISSION_EXPORT_FORMAT) {
    SUBMISSION_EXPORT_FORMAT["CSV"] = "CSV";
    SUBMISSION_EXPORT_FORMAT["SHAPEFILE"] = "SHAPEFILE";
    SUBMISSION_EXPORT_FORMAT["GPKG"] = "GPKG";
    return SUBMISSION_EXPORT_FORMAT;
}({});
var WARNING_CATEGORIES = /*#__PURE__*/ function(WARNING_CATEGORIES) {
    WARNING_CATEGORIES["IMPROVEMENTS"] = "improvements";
    WARNING_CATEGORIES["IS_WITHIN_SFHA"] = "isWithinSFHA";
    WARNING_CATEGORIES["FLOOD_MAP_CHANGES"] = "floodMapChanges";
    WARNING_CATEGORIES["LFE_BELOW_BFE"] = "lfeBelowBfe";
    WARNING_CATEGORIES["MACHINERY_BELOW_BFE"] = "machineryBelowBfe";
    WARNING_CATEGORIES["PRELIMINARY_DAMAGE_ASSESSMENT"] = "preliminaryDamageAssessment";
    WARNING_CATEGORIES["REPETITIVE_LOSS"] = "repetitiveLoss";
    return WARNING_CATEGORIES;
}({});
const PDA_WARNING_CODES = [
    "PRELIMINARY_DAMAGE_ASSESSMENT.NONE",
    "PRELIMINARY_DAMAGE_ASSESSMENT.AFFECTED",
    "PRELIMINARY_DAMAGE_ASSESSMENT.MINOR",
    "PRELIMINARY_DAMAGE_ASSESSMENT.MAJOR",
    "PRELIMINARY_DAMAGE_ASSESSMENT.DESTROYED",
    "PRELIMINARY_DAMAGE_ASSESSMENT.UNKNOWN"
];
const FIRM_WARNING_CATEGORIES = [
    "isWithinSFHA",
    "floodMapChanges",
    "lfeBelowBfe",
    "machineryBelowBfe"
];
var RULE_FILTER_TYPE = /*#__PURE__*/ function(RULE_FILTER_TYPE) {
    RULE_FILTER_TYPE["MAP"] = "map";
    RULE_FILTER_TYPE["STRING"] = "string";
    return RULE_FILTER_TYPE;
}({});
var SUBMISSION_TYPE_MODULE = /*#__PURE__*/ function(SUBMISSION_TYPE_MODULE) {
    SUBMISSION_TYPE_MODULE["PRELIMINARY_DAMAGE_ASSESSMENT"] = "preliminary_damage_assessment";
    SUBMISSION_TYPE_MODULE["SUBSTANTIAL_DAMAGE_ESTIMATE"] = "substantial_damage_estimate";
    SUBMISSION_TYPE_MODULE["SUBSTANTIAL_IMPROVEMENT_SUBSTANTIAL_DAMAGE"] = "substantial_improvement_substantial_damage";
    SUBMISSION_TYPE_MODULE["EC_SUBMISSION"] = "ec_submission";
    SUBMISSION_TYPE_MODULE["MILESTONE_INSPECTION"] = "milestone_inspection";
    SUBMISSION_TYPE_MODULE["MAILINGS"] = "mailings";
    return SUBMISSION_TYPE_MODULE;
}({});
var DATA_TYPE = /*#__PURE__*/ function(DATA_TYPE) {
    DATA_TYPE["STRING"] = "string";
    DATA_TYPE["NUMBER"] = "number";
    DATA_TYPE["BOOLEAN"] = "boolean";
    DATA_TYPE["DATETIME"] = "datetime";
    DATA_TYPE["DATE"] = "date";
    DATA_TYPE["GEOMETRY"] = "geometry";
    DATA_TYPE["ENUM"] = "enum";
    DATA_TYPE["UUID"] = "uuid";
    DATA_TYPE["ARRAY"] = "array";
    DATA_TYPE["URL"] = "url";
    return DATA_TYPE;
}({});
var EC_CONFIGURATION_FLOOD_MAP_RESTRICTION = /*#__PURE__*/ function(EC_CONFIGURATION_FLOOD_MAP_RESTRICTION) {
    EC_CONFIGURATION_FLOOD_MAP_RESTRICTION["ALL"] = "all";
    EC_CONFIGURATION_FLOOD_MAP_RESTRICTION["SFHA_EFFECTIVE"] = "sfha_effective";
    return EC_CONFIGURATION_FLOOD_MAP_RESTRICTION;
}({});
var DATUM_CONVERSION_OFFSET_SOURCE = /*#__PURE__*/ function(DATUM_CONVERSION_OFFSET_SOURCE) {
    DATUM_CONVERSION_OFFSET_SOURCE["NOAA"] = "NOAA";
    DATUM_CONVERSION_OFFSET_SOURCE["COUNTY"] = "County";
    DATUM_CONVERSION_OFFSET_SOURCE["ACCOUNT_OVERRIDE"] = "Account Override";
    return DATUM_CONVERSION_OFFSET_SOURCE;
}({});
const ARC_GIS_TYPE_TO_DATA_TYPE = {
    esriFieldTypeDate: "datetime",
    esriFieldTypeDateOnly: "date",
    esriFieldTypeDouble: "number",
    esriFieldTypeGUID: "string",
    esriFieldTypeGeometry: "geometry",
    esriFieldTypeGlobalID: "string",
    esriFieldTypeInteger: "number",
    esriFieldTypeBigInteger: "number",
    esriFieldTypeOID: "string",
    esriFieldTypeRaster: "geometry",
    esriFieldTypeSingle: "number",
    esriFieldTypeSmallInteger: "number",
    esriFieldTypeString: "string",
    esriFieldTypeXML: "string"
};
var PROPERTY_INFORMATION_SECTION_CODE = /*#__PURE__*/ function(PROPERTY_INFORMATION_SECTION_CODE) {
    PROPERTY_INFORMATION_SECTION_CODE["FLOOD_INFO"] = "flood_info";
    PROPERTY_INFORMATION_SECTION_CODE["BUILDING_INFO"] = "building_info";
    PROPERTY_INFORMATION_SECTION_CODE["PARCEL_INFO"] = "parcel_info";
    PROPERTY_INFORMATION_SECTION_CODE["REPETITIVE_LOSS"] = "repetitive_loss";
    PROPERTY_INFORMATION_SECTION_CODE["CUSTOM"] = "custom";
    return PROPERTY_INFORMATION_SECTION_CODE;
}({});
const NON_MAPBOX_TILESET_ID = "fake-id";
var EC_REVIEW_STATUS = /*#__PURE__*/ function(EC_REVIEW_STATUS) {
    EC_REVIEW_STATUS["NEEDS_REVIEW"] = "needs_review";
    return EC_REVIEW_STATUS;
}({});
var TAG_DISPLAY = /*#__PURE__*/ function(TAG_DISPLAY) {
    TAG_DISPLAY["DEFAULT"] = "default";
    TAG_DISPLAY["NEUTRAL"] = "neutral";
    TAG_DISPLAY["WARNING"] = "warning";
    TAG_DISPLAY["CRITICAL"] = "critical";
    TAG_DISPLAY["NEUTRAL_INVERTED"] = "neutralInverted";
    return TAG_DISPLAY;
}({});
const IMAGE_RECOVERY_S3KEY = "image_recovery_data";
var OBJECT_TYPE = /*#__PURE__*/ function(OBJECT_TYPE) {
    OBJECT_TYPE["PROPERTY"] = "property";
    OBJECT_TYPE["CUSTOM_MAP_GEOMETRY"] = "customMapGeometry";
    return OBJECT_TYPE;
}({});
const PROPERTY_OBJECT_LABEL = "Property";
const REQUEST_ID_HEADER = "x-request-id";
var SUPPORTED_LANGUAGES = /*#__PURE__*/ function(SUPPORTED_LANGUAGES) {
    SUPPORTED_LANGUAGES["ENGLISH"] = "en";
    SUPPORTED_LANGUAGES["SPANISH"] = "es";
    return SUPPORTED_LANGUAGES;
}({});
const FEMA_FIRM_TYPES = [
    "effective",
    "preliminary"
];
const EFFECTIVE_LIKE_FIRM_TYPES = [
    "effective",
    "historic_effective"
];
const BATCH_JOB_MAIN_CONTAINER_NAME = "main-container";
const modelNamesToColumnNames = {
    parcelId: "parcelnumb",
    landValue: "landval",
    parcelValue: "parval",
    improvementValue: "improvval",
    mailingAddress1: "mailadd",
    mailingAddress2: "mail_address2",
    yearBuilt: "yearbuilt",
    buildingDescription: "property_buildingdescription",
    legalDescription: "legaldesc",
    hiddenFromPublic: "hidden_from_public"
};
var LOGOUT_REASON = /*#__PURE__*/ function(LOGOUT_REASON) {
    LOGOUT_REASON["INACTIVITY"] = "inactivity";
    LOGOUT_REASON["PASSWORD_RESET"] = "password_reset";
    return LOGOUT_REASON;
}({});
var AI_ACTION_RUN_STATUS = /*#__PURE__*/ function(AI_ACTION_RUN_STATUS) {
    AI_ACTION_RUN_STATUS["PENDING"] = "pending";
    AI_ACTION_RUN_STATUS["RUNNING"] = "running";
    AI_ACTION_RUN_STATUS["SUCCEEDED"] = "succeeded";
    AI_ACTION_RUN_STATUS["FAILED"] = "failed";
    return AI_ACTION_RUN_STATUS;
}({});
var TASK_STATUS = /*#__PURE__*/ function(TASK_STATUS) {
    TASK_STATUS["TO_DO"] = "to_do";
    TASK_STATUS["IN_PROGRESS"] = "in_progress";
    TASK_STATUS["COMPLETE"] = "complete";
    return TASK_STATUS;
}({});
var TASK_ASSIGNEE_TYPE = /*#__PURE__*/ function(TASK_ASSIGNEE_TYPE) {
    TASK_ASSIGNEE_TYPE["USER"] = "user";
    return TASK_ASSIGNEE_TYPE;
}({});
var TASK_RECORD_INTENTION = /*#__PURE__*/ function(TASK_RECORD_INTENTION) {
    // the task was made for reviewing the related record
    TASK_RECORD_INTENTION["REVIEW"] = "review";
    // the task was made for creating a record
    TASK_RECORD_INTENTION["CREATE"] = "create";
    return TASK_RECORD_INTENTION;
}({});
var PUBLIC_USER_STATUS = /*#__PURE__*/ function(PUBLIC_USER_STATUS) {
    PUBLIC_USER_STATUS["UNCONFIRMED"] = "unconfirmed";
    PUBLIC_USER_STATUS["PENDING"] = "pending";
    PUBLIC_USER_STATUS["ACTIVE"] = "active";
    PUBLIC_USER_STATUS["SUSPENDED"] = "suspended";
    PUBLIC_USER_STATUS["DENIED"] = "denied";
    return PUBLIC_USER_STATUS;
}({});
const PUBLIC_USER_STATUS_TO_TEXT = {
    ["unconfirmed"]: "Unconfirmed",
    ["pending"]: "Pending",
    ["active"]: "Active",
    ["suspended"]: "Suspended",
    ["denied"]: "Denied"
};
var WORKFLOW_DEFINITION_STATUS = /*#__PURE__*/ function(WORKFLOW_DEFINITION_STATUS) {
    WORKFLOW_DEFINITION_STATUS["DRAFT"] = "draft";
    WORKFLOW_DEFINITION_STATUS["OPEN"] = "open";
    WORKFLOW_DEFINITION_STATUS["CLOSED"] = "closed";
    return WORKFLOW_DEFINITION_STATUS;
}({});
var WORKFLOW_STEP_STATUS = /*#__PURE__*/ function(WORKFLOW_STEP_STATUS) {
    WORKFLOW_STEP_STATUS["IN_PROGRESS"] = "in_progress";
    WORKFLOW_STEP_STATUS["SUCCEEDED"] = "success";
    WORKFLOW_STEP_STATUS["FAILED"] = "failed";
    WORKFLOW_STEP_STATUS["SKIPPED"] = "skipped";
    return WORKFLOW_STEP_STATUS;
}({});
var WORKFLOW_STEP_MANUAL_STATUS = /*#__PURE__*/ function(WORKFLOW_STEP_MANUAL_STATUS) {
    WORKFLOW_STEP_MANUAL_STATUS["LOCKED"] = "LOCKED";
    WORKFLOW_STEP_MANUAL_STATUS["OPEN"] = "OPEN";
    WORKFLOW_STEP_MANUAL_STATUS["COMPLETE"] = "COMPLETE";
    WORKFLOW_STEP_MANUAL_STATUS["REJECTED"] = "REJECTED";
    WORKFLOW_STEP_MANUAL_STATUS["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    return WORKFLOW_STEP_MANUAL_STATUS;
}({});
var WORKFLOW_STATUS_MODE = /*#__PURE__*/ function(WORKFLOW_STATUS_MODE) {
    WORKFLOW_STATUS_MODE["MANUAL"] = "MANUAL";
    WORKFLOW_STATUS_MODE["LEGACY_AUTOMATIC"] = "LEGACY_AUTOMATIC";
    return WORKFLOW_STATUS_MODE;
}({});
var WORKFLOW_STATUS = /*#__PURE__*/ function(WORKFLOW_STATUS) {
    WORKFLOW_STATUS["LOCKED"] = "Locked";
    WORKFLOW_STATUS["OPEN"] = "Open";
    WORKFLOW_STATUS["COMPLETE"] = "Complete";
    WORKFLOW_STATUS["REJECTED"] = "Rejected";
    return WORKFLOW_STATUS;
}({});
var FEATURED_ITEM_ENTITY_TYPE = /*#__PURE__*/ function(FEATURED_ITEM_ENTITY_TYPE) {
    FEATURED_ITEM_ENTITY_TYPE["SUBMISSION_TYPE"] = "SubmissionType";
    FEATURED_ITEM_ENTITY_TYPE["WORKFLOW_DEFINITION"] = "WorkflowDefinition";
    FEATURED_ITEM_ENTITY_TYPE["SAVED_VIEW"] = "SavedView";
    return FEATURED_ITEM_ENTITY_TYPE;
}({});
var FEATURED_ITEM_LINK_TYPE = /*#__PURE__*/ function(FEATURED_ITEM_LINK_TYPE) {
    FEATURED_ITEM_LINK_TYPE["TABLE"] = "table";
    FEATURED_ITEM_LINK_TYPE["MAP_LAYER"] = "mapLayer";
    return FEATURED_ITEM_LINK_TYPE;
}({});
const INTERNAL_APP_SUBDOMAIN = "app";
var CREATOR_TYPE = /*#__PURE__*/ function(CREATOR_TYPE) {
    CREATOR_TYPE["TEAM"] = "Team";
    CREATOR_TYPE["GUESTS"] = "Guests";
    return CREATOR_TYPE;
}({});
var GEOM_CREATION_TYPE = /*#__PURE__*/ function(GEOM_CREATION_TYPE) {
    GEOM_CREATION_TYPE["IMPORT"] = "import";
    GEOM_CREATION_TYPE["MANUAL"] = "manual";
    return GEOM_CREATION_TYPE;
}({});
var V2_PIPELINE_STATUS = /*#__PURE__*/ function(V2_PIPELINE_STATUS) {
    V2_PIPELINE_STATUS["OFF"] = "off";
    V2_PIPELINE_STATUS["LIVE"] = "live";
    return V2_PIPELINE_STATUS;
}({});
var PASSWORD_VALIDATION_ERROR_CODE = /*#__PURE__*/ function(PASSWORD_VALIDATION_ERROR_CODE) {
    PASSWORD_VALIDATION_ERROR_CODE["ONE_UPPERCASE_CHARACTER"] = "one_uppercase_character";
    PASSWORD_VALIDATION_ERROR_CODE["ONE_NUMBER"] = "one_number";
    PASSWORD_VALIDATION_ERROR_CODE["ONE_SPECIAL_CHARACTER"] = "one_special_character";
    PASSWORD_VALIDATION_ERROR_CODE["MINIMUM_LENGTH"] = "minimum_length";
    return PASSWORD_VALIDATION_ERROR_CODE;
}({});
var GEOCODE_ACCURACY_PROFILE = /*#__PURE__*/ function(GEOCODE_ACCURACY_PROFILE) {
    GEOCODE_ACCURACY_PROFILE["EXCLUDE_RANGE_INTERPOLATION"] = "excludeRangeInterpolation";
    GEOCODE_ACCURACY_PROFILE["ROOFTOP"] = "rooftop";
    GEOCODE_ACCURACY_PROFILE["ANY"] = "any";
    return GEOCODE_ACCURACY_PROFILE;
}({});
const DEFAULT_PUBLIC_USER_GROUP_NAME = "Resident";
var PASSWORD_RESET_REQUESTER_TYPE = /*#__PURE__*/ function(PASSWORD_RESET_REQUESTER_TYPE) {
    PASSWORD_RESET_REQUESTER_TYPE["USER"] = "user";
    PASSWORD_RESET_REQUESTER_TYPE["PUBLIC_USER"] = "publicUser";
    return PASSWORD_RESET_REQUESTER_TYPE;
}({});
var ROW_SELECTION_MODE = /*#__PURE__*/ function(ROW_SELECTION_MODE) {
    ROW_SELECTION_MODE["NONE"] = "none";
    ROW_SELECTION_MODE["IDS"] = "ids";
    ROW_SELECTION_MODE["ALL"] = "all";
    ROW_SELECTION_MODE["ALL_EXCEPT_IDS"] = "allExceptIds";
    return ROW_SELECTION_MODE;
}({});
var ADDRESS_STANDARDIZERS = /*#__PURE__*/ function(ADDRESS_STANDARDIZERS) {
    ADDRESS_STANDARDIZERS["GOOGLE"] = "GOOGLE";
    return ADDRESS_STANDARDIZERS;
}({});
var THIRD_PARTY_SYSTEM_TYPE = /*#__PURE__*/ function(THIRD_PARTY_SYSTEM_TYPE) {
    THIRD_PARTY_SYSTEM_TYPE["ACCELA"] = "accela";
    return THIRD_PARTY_SYSTEM_TYPE;
}({});
var AUTOMATION_NODE_TYPE = /*#__PURE__*/ function(AUTOMATION_NODE_TYPE) {
    AUTOMATION_NODE_TYPE["SEARCH_RECORDS"] = "searchRecords";
    AUTOMATION_NODE_TYPE["UPDATE_CUSTOM_TABLE"] = "updateCustomTable";
    AUTOMATION_NODE_TYPE["CREATE_OR_UPDATE_SUBMISSION"] = "createOrUpdateSubmission";
    AUTOMATION_NODE_TYPE["GET_RECORD_DOCUMENTS"] = "getRecordDocuments";
    AUTOMATION_NODE_TYPE["DOWNLOAD_ACCELA_DOCUMENT"] = "downloadAccelaDocument";
    AUTOMATION_NODE_TYPE["CREATE_DOCUMENT_UPLOAD"] = "createDocumentUpload";
    AUTOMATION_NODE_TYPE["SEND_REPORT"] = "sendReport";
    AUTOMATION_NODE_TYPE["LOAD_FORERUNNER_DATA"] = "loadForerunnerData";
    AUTOMATION_NODE_TYPE["GET_ACCELA_DOCUMENT"] = "getAccelaDocument";
    AUTOMATION_NODE_TYPE["UPDATE_WORKFLOW_TASK_STATUS"] = "updateWorkflowTaskStatus";
    AUTOMATION_NODE_TYPE["UPDATE_RECORD_CONDITION"] = "updateRecordCondition";
    AUTOMATION_NODE_TYPE["ROUTER"] = "router";
    return AUTOMATION_NODE_TYPE;
}({});
var COMMENT_OBJECT_TYPE = /*#__PURE__*/ function(COMMENT_OBJECT_TYPE) {
    COMMENT_OBJECT_TYPE["PROPERTY"] = "property";
    COMMENT_OBJECT_TYPE["CUSTOM_MAP_GEOMETRY"] = "customMapGeometry";
    COMMENT_OBJECT_TYPE["SUBMISSION"] = "submission";
    return COMMENT_OBJECT_TYPE;
}({});
var COMMENT_CREATED_BY_TYPE = /*#__PURE__*/ function(COMMENT_CREATED_BY_TYPE) {
    COMMENT_CREATED_BY_TYPE["USER"] = "user";
    COMMENT_CREATED_BY_TYPE["ADMIN"] = "admin";
    COMMENT_CREATED_BY_TYPE["PUBLIC_USER"] = "publicUser";
    return COMMENT_CREATED_BY_TYPE;
}({});
var USER_AUTH_METHOD = /*#__PURE__*/ function(USER_AUTH_METHOD) {
    USER_AUTH_METHOD["PASSWORD"] = "password";
    USER_AUTH_METHOD["SSO"] = "sso";
    return USER_AUTH_METHOD;
}({});
var DOCUMENT_UPLOAD_DETAIL_TAB_NAME = /*#__PURE__*/ function(DOCUMENT_UPLOAD_DETAIL_TAB_NAME) {
    DOCUMENT_UPLOAD_DETAIL_TAB_NAME["FORM_FIELDS"] = "formFields";
    DOCUMENT_UPLOAD_DETAIL_TAB_NAME["SETTINGS"] = "settings";
    DOCUMENT_UPLOAD_DETAIL_TAB_NAME["ISSUES"] = "issues";
    DOCUMENT_UPLOAD_DETAIL_TAB_NAME["EXTRACTED_FIELDS"] = "extractedFields";
    DOCUMENT_UPLOAD_DETAIL_TAB_NAME["LOCATION"] = "location";
    return DOCUMENT_UPLOAD_DETAIL_TAB_NAME;
}({});
var CONDITIONAL_RULE_EFFECT_ACTION = /*#__PURE__*/ function(CONDITIONAL_RULE_EFFECT_ACTION) {
    CONDITIONAL_RULE_EFFECT_ACTION["SHOW"] = "show";
    CONDITIONAL_RULE_EFFECT_ACTION["HIDE"] = "hide";
    return CONDITIONAL_RULE_EFFECT_ACTION;
}({});
var SUBMISSION_TAB = /*#__PURE__*/ function(SUBMISSION_TAB) {
    SUBMISSION_TAB["FORM"] = "form";
    SUBMISSION_TAB["COMMENTS"] = "comments";
    return SUBMISSION_TAB;
}({});
var HELPSCOUT_BEACON_PAGE = /*#__PURE__*/ function(HELPSCOUT_BEACON_PAGE) {
    HELPSCOUT_BEACON_PAGE["HOME"] = "HOME";
    HELPSCOUT_BEACON_PAGE["EXPLORE_MAP"] = "EXPLORE_MAP";
    HELPSCOUT_BEACON_PAGE["PROPERTY_PROFILE"] = "PROPERTY_PROFILE";
    HELPSCOUT_BEACON_PAGE["NOT_FOUND"] = "NOT_FOUND";
    HELPSCOUT_BEACON_PAGE["EC"] = "EC";
    HELPSCOUT_BEACON_PAGE["GET_HELP"] = "GET_HELP";
    return HELPSCOUT_BEACON_PAGE;
}({});
var AUTOMATION_TRIGGER_TYPE = /*#__PURE__*/ function(AUTOMATION_TRIGGER_TYPE) {
    AUTOMATION_TRIGGER_TYPE["HOURLY"] = "hourly";
    AUTOMATION_TRIGGER_TYPE["EC_ISSUES_PROCESSED"] = "ec_issues_processed";
    AUTOMATION_TRIGGER_TYPE["DAILY"] = "daily";
    AUTOMATION_TRIGGER_TYPE["SUBMISSION_CREATED"] = "submission_created";
    AUTOMATION_TRIGGER_TYPE["SUBMISSION_UPDATED"] = "submission_updated";
    return AUTOMATION_TRIGGER_TYPE;
}({});
var AUTOMATION_RESOURCE_TYPE = /*#__PURE__*/ function(AUTOMATION_RESOURCE_TYPE) {
    AUTOMATION_RESOURCE_TYPE["SUBMISSION_TYPE"] = "submissionType";
    return AUTOMATION_RESOURCE_TYPE;
}({});
const NUM_SEARCH_RESULTS = 10;
var SEARCH_RESULT_TYPE = /*#__PURE__*/ function(SEARCH_RESULT_TYPE) {
    SEARCH_RESULT_TYPE["PROPERTY"] = "PropertySearchResult";
    SEARCH_RESULT_TYPE["PARCEL"] = "ParcelSearchResult";
    SEARCH_RESULT_TYPE["CUSTOM_MAP_GEOMETRY"] = "CustomMapGeometrySearchResult";
    return SEARCH_RESULT_TYPE;
}({});

//# sourceMappingURL=data:application/json;base64,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